import React from 'react'
import { useState, useEffect } from 'react'
import {
  makeStyles,
  Container,
  Paper,
  Tabs,
  Tab,
  Divider,
} from '@material-ui/core'
import Layout from '../components/common/Layout'
import NewShell from '../components/pages-new/NewShell'
import theme from '../components/common/theme'
import ConsentUpdateDetail from '../components/common/ConsentUpdateDetail'

import LegalStyleDiv from '../components/common/Consents/LegalStyleDiv'
import LegalOrderingDiv from '../components/common/Consents/LegalOrderingDiv'
import LegalBodyDiv from '../components/common/Consents/LegalBodyDiv'
import LegalLiEle from '../components/common/Consents/LegalLiEle'

import { useRouter } from 'next/router'

const Terms = ({ isNew }) => {
  const [activeTab, setActiveTab] = useState(0)
  const Router = useRouter()
  const language = Router.locale
  const isEnglish = language === 'en'

  useEffect(() => {
    if (!Router.isReady) return
    if (Router.query.tab === 'inter') setActiveTab(1)
  }, [Router.isReady])

  const useStyles = makeStyles({
    root: {
      minHeight: '100vh',
      width: '100vw',
      display: 'flex',
      flexDirection: 'column',
    },
    page: {
      width: '100vw',
      flexGrow: 1,
      padding: '20px 0',
    },
    paper: {
      width: '100%',
      padding: 20,
      paddingTop: 0,
      '& > :not(h1)': {
        fontFamily: 'Helvetica, sans-serif',
      },
      '& > h1': {
        color: theme.palette.primary.main,
        textAlign: 'center',
        marginTop: 50,
      },
      '& > h2': {
        textAlign: 'center',
      },
    },
    strongStyle: {
      fontWeight: '800',
    },
    cloneOlStyle: {
      display: 'block',
      marginBlockStart: '1em',
      marginInlineStart: '0px',
      marginInlineEnd: '0px',
    },
    toRight: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
  })

  const classes = useStyles()

  const trans = (engText, thaiText) => {
    return isEnglish ? engText : thaiText
  }

  const DomesticContent = () => (
    <>
      <h1>{trans('Terms of Use', 'เงื่อนไขการใช้บริการ (Terms of Use)')}</h1>
      <h2>{trans('For Domestic Services', 'สำหรับการบริการภายในประเทศ')}</h2>
      <p>
        {trans(
          'Shippop Co., Ltd. is the logistic service provider that integrates domestic and international couriers into a single system. By using the Services through this website, application, or our other channels, the User will be able to use various services that make shipping convenient, fast, safe, and easy.',
          'บริษัท ชิปป๊อป จำกัด เป็นผู้ให้บริการด้านการขนส่งที่รวบรวมและเชื่อมโยงผู้ให้บริการขนส่งทั้งในและต่างประเทศมาไว้ในระบบเดียวเพื่อให้การขนส่งสะดวก รวดเร็ว ปลอดภัยและใช้ได้ทุกที่ทุกเวลา โดยผู้ใช้บริการไม่ว่าจะเป็นบุคคลทั่วไปหรือพ่อค้าแม่ค้าออนไลน์สามารถเลือกใช้บริการได้หลากหลายผ่านเว็บไซต์ แอปพลิเคชันหรือช่องทางของเราในรูปแบบต่างๆ'
        )}
      </p>
      <p>
        {trans(
          'These Terms bind the User legally and serve as a declaration of rights and obligations that the User must understand and follow. Please read through these Terms carefully for your rights and benefit. By creating an account or using the Services, you agree to and fully understand these Terms and the Privacy Policy referenced herein.',
          'เงื่อนไขการใช้บริการฉบับนี้มีผลผูกพันผู้ใช้บริการตามกฏหมายและมีวัตถุประสงค์เพื่อแจ้งให้ทราบถึงสิทธิและหน้าที่ตามกฏหมายอันพึงต้องปฏิบัติตาม โปรดอ่านเงื่อนไขการใช้บริการนี้โดยละเอียดเพื่อประโยชน์ในการรับบริการจากเรา การสมัครหรือการใช้บริการโดยผู้ใช้บริการจะถือว่าผู้ใช้บริการยอมรับว่าได้อ่านและทำความเข้าใจเงื่อนไขการใช้บริการและนโยบายความเป็นส่วนตัวโดยละเอียดถี่ถ้วนแล้ว โดยผู้ใช้บริการตกลงผูกพันและปฏิบัติตามเงื่อนไขการใช้บริการและนโยบายความเป็นส่วนตัวทุกประการ'
        )}
      </p>
      <ol>
        <li>
          <span className={classes.strongStyle}>
            {trans('Definition', 'คำจำกัดความ')}
          </span>
          <p>
            {trans(
              'Unless otherwise indicated in these Terms, the following words, when used herein, shall have the following meanings throughout these Terms:',
              'นอกเหนือจากที่ระบุไว้ในเงื่อนไขการใช้บริการนี้ ให้คำดังต่อไปนี้มีความหมายตามที่ระบุไว้ในข้อนี้ เว้นแต่มีการกำหนดเป็นอย่างอื่น'
            )}
          </p>
          <LegalStyleDiv>
            <LegalOrderingDiv>1)</LegalOrderingDiv>
            <div>
              {isEnglish ? (
                <>
                  <span className={classes.strongStyle}>
                    “Service Provider”
                  </span>{' '}
                  <span>or</span>{' '}
                  <span className={classes.strongStyle}>“We” </span>
                </>
              ) : (
                <span className={classes.strongStyle}>“ผู้ให้บริการ”</span>
              )}
              <span>
                {trans(
                  'means Shippop Co., Ltd., the host of the SHIPPOP websites and/or applications.',
                  'หมายถึง บริษัท ชิปป๊อป จำกัด ซึ่งเป็นผู้ให้บริการเว็บไซต์และแอปพลิเคชัน SHIPPOP หรือชื่ออื่นใดอันหมายถึงบริการดังกล่าว'
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>2)</LegalOrderingDiv>
            <div>
              <span className={classes.strongStyle}>
                {trans('“User”', '“ผู้ใช้บริการ” ')}
              </span>{' '}
              <span>
                {trans(
                  'means a person who accesses, enters, registers, or uses any of the Service Provider’s products, software, services, websites, or applications and shall mean to include the User of these Services.',
                  'หมายถึง บุคคลใดก็ตามที่เข้าถึง เข้า ลงทะเบียน หรือใช้งานผลิตภัณฑ์ ซอฟต์แวร์ บริการ เว็บไซต์ หรือแอปพลิเคชันของผู้ให้บริการไม่ว่าส่วนใดส่วนหนึ่งหรือทั้งหมดและให้หมายรวมถึงผู้ใช้บริการที่ใช้งานโดยตรงผ่านเว็บไซต์ แอปพลิชัน และ/หรือช่องทางของเราในรูปแบบต่างๆ'
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>3)</LegalOrderingDiv>
            <div>
              <span className={classes.strongStyle}>
                {trans('“Courier”', '“ผู้ให้บริการขนส่ง”')}
              </span>
              <span>
                {trans(
                  'means any of our courier partners that provide their services through our websites, applications, and other channels.',
                  'หมายถึง ผู้ให้บริกาารขนส่งซึ่งเป็นพาร์ทเนอร์กับผู้ให้บริการ ซึ่งผู้ใช้บริการสามารถเลือกใช้บริการของผู้ให้บริกาารขนส่งดังกล่าวได้ผ่านช่องทางต่าง ๆ ของผู้ให้บริการ'
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>4)</LegalOrderingDiv>
            <div>
              <span className={classes.strongStyle}>
                {trans('“Terms”', '“เงื่อนไขการใช้บริการ”')}
              </span>
              <span>
                {trans(
                  'means agreements, terms, clauses, contracts, or any other similar title declaring legal rights and obligations, including the Privacy Policy, which is considered as part of these Terms.',
                  'หมายถึง ข้อตกลง ข้อกำหนด ข้อสัญญา หรือชื่ออื่นใดที่มีลักษณะแบบเดียวกันเพื่อแจ้งให้ทราบถึงสิทธิและหน้าที่ตามกฎหมาย รวมถึงนโยบายความเป็นส่วนตัวซึ่งถือเป็นส่วนหนึ่งของเงื่อนไขการใช้บริการฉบับนี้'
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>5)</LegalOrderingDiv>
            <div>
              <span className={classes.strongStyle}>
                {trans('“Services”', '“บริการ”')}
              </span>
              <span>
                {trans(
                  'means the services offered through our website, application,  and other channels. The services include:',
                  'หมายถึง การให้บริการดังต่อไปนี้ผ่านเว็บไซต์ แอปพลิชัน และ/หรือผ่านช่องทางของเราในรูปแบบต่างๆ'
                )}
              </span>
              <ul style={{ listStyleType: 'disc' }}>
                <LegalLiEle>
                  {trans(
                    'Comparing shipping costs, and booking and managing delivery service; ',
                    'บริการค้นหาและเปรียบเทียบค่าขนส่งมาไว้ในระบบเดียว รวมทั้งบริการประสานงานและจัดการการขนส่ง'
                  )}
                </LegalLiEle>
                <LegalLiEle>
                  {trans('Label printing service;', 'บริการพิมพ์ใบปะหน้าพัสดุ')}
                </LegalLiEle>
                <LegalLiEle>
                  {trans(
                    'Parcel Pickup and Parcel Dropoff service;',
                    'บริการเข้ารับพัสดุหรือส่งพัสดุด้วยตนเอง'
                  )}
                </LegalLiEle>
                <LegalLiEle>
                  {trans(
                    'Cash on delivery service (COD);',
                    'บริการเก็บเงินปลายทาง (COD)'
                  )}
                </LegalLiEle>
                <LegalLiEle>
                  {trans(
                    'Track and Trace service;',
                    'บริการตรวจสอบสถานะขนส่งพัสดุ'
                  )}
                </LegalLiEle>
                <LegalLiEle>
                  {trans(
                    'Insurance service;',
                    'บริการประกันคุ้มครองการจัดส่งพัสดุ'
                  )}
                </LegalLiEle>
                <LegalLiEle>
                  {trans('SHIPPOP PRO Service; and', 'บริการ SHIPPOP PRO')}
                </LegalLiEle>
                <LegalLiEle>
                  {trans(
                    'any other service or feature that the Service Provider may offer to the User from time to time at its sole discretion.',
                    'บริการอื่นใดที่ผู้ให้บริการจัดให้มีขึ้นในอนาคต'
                  )}
                </LegalLiEle>
              </ul>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>6)</LegalOrderingDiv>
            <div>
              <span className={classes.strongStyle}>
                {trans('“Information” ', '“ข้อมูล” ')}
              </span>{' '}
              <span>
                {trans(
                  'means any information provided to the Service Provider via the websites, applications, and other channels.',
                  'หมายถึง ข้อมูลใด ๆ ที่ผู้ใช้บริการหรือผู้ที่ได้รับมอบอำนาจจากผู้ใช้บริการให้ทำการแทนได้ให้ไว้แก่ผู้ให้บริการผ่านทางช่องทางต่าง ๆ ไม่ว่าจะเป็นเว็บไซต์หรือแอปพลิเคชัน'
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>7)</LegalOrderingDiv>
            <div>
              <span className={classes.strongStyle}>
                {trans('“Identification Code”', '“รหัสประจำตัว”')}
              </span>{' '}
              <span>
                {trans(
                  'means Username, Password, OTP – One Time Password, whether designated by the Service Provider for the User or by the User oneself, including any other passcode or identity verification process, whatever it is called, relating to access to these Services.',
                  'หมายถึง ชื่อผู้ใช้งาน (Username) รหัสผ่าน (Password) และ รหัส OTP – One Time Password รวมถึงรหัสอื่นใด หรือวิธีการยืนยันตัวบุคคลอื่นใดที่เกี่ยวข้องกับการเข้าใช้บริการนี้ โดยไม่ว่าจะเป็นรหัสที่ผู้ใช้บริการหรือผู้ให้บริการเป็นผู้กำหนด'
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>8)</LegalOrderingDiv>
            <div>
              <span className={classes.strongStyle}>
                {trans('“Services Fees”', '“ค่าบริการ”')}
              </span>{' '}
              <span>
                {trans(
                  'means fees that the User agrees to pay for the Services provided by the Service Provider.',
                  'หมายถึง ค่าบริการที่ผู้ใช้บริการตกลงยินยอมตามที่ผู้ให้บริการเรียกเก็บ'
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>9)</LegalOrderingDiv>
            <div>
              <span className={classes.strongStyle}>
                {trans('“Agent”', '“ตัวแทน”')}
              </span>{' '}
              <span>
                {trans(
                  'means a person or an entity appointed by the Service Provider to use the system whether in whole or in part.',
                  'หมายถึง บุคคลและหรือนิติบุคคลใดก็ตาม หรือชื่ออื่นใดอันมีความหมายเดียวกัน ที่ได้รับอนุญาตและ/หรือได้รับแต่งตั้งให้สามารถนำระบบของ SHIPPOP ทั้งหมดหรือบางส่วนไปใช้'
                )}
              </span>
            </div>
          </LegalStyleDiv>
        </li>

        <li>
          <p>
            <span className={classes.strongStyle}>
              {' '}
              {trans('Prohibited Items', 'ขอบเขตการให้บริการ')}
            </span>
          </p>
          <p>
            {trans(
              'The Service Provider reserves the right to not provide these Services to the following items:',
              'ผู้ให้บริการขอสงวนสิทธิ์ไม่ให้บริการสำหรับพัสดุดังต่อไปนี้'
            )}
          </p>
          <LegalStyleDiv>
            <LegalOrderingDiv>1)</LegalOrderingDiv>
            <LegalBodyDiv multiply={1}>
              <span>{trans('Live animals;', 'สัตว์มีชีวิต')}</span>
            </LegalBodyDiv>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>2)</LegalOrderingDiv>
            <LegalBodyDiv multiply={1}>
              <span>{trans('Narcotics;', 'สิ่งเสพติด')}</span>{' '}
            </LegalBodyDiv>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>3)</LegalOrderingDiv>
            <LegalBodyDiv multiply={1}>
              <span>
                {trans(
                  'Pornography or prohibited items;',
                  'สิ่งลามกอนาจาร หรือสิ่งที่มีถ้อยคำ เครื่องหมาย ลวดลาย หยาบช้า'
                )}
              </span>{' '}
            </LegalBodyDiv>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>4)</LegalOrderingDiv>
            <LegalBodyDiv multiply={1}>
              <span>{trans('Flammable substances;', 'วัตถุไวไฟ')}</span>
            </LegalBodyDiv>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>5)</LegalOrderingDiv>
            <LegalBodyDiv multiply={1}>
              <span>
                {trans(
                  'Sharp materials without proper packaging;',
                  'วัตถุมีคมที่ไม่มีเครื่องหุ้มห่อ ป้องกัน'
                )}
              </span>{' '}
            </LegalBodyDiv>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>6)</LegalOrderingDiv>
            <LegalBodyDiv multiply={1}>
              <span>
                {trans(
                  'Items without proper or adequate packaging;',
                  'วัตถุที่บรรจุหีบห่อไม่เหมาะสมต่อการขนส่ง'
                )}
              </span>
            </LegalBodyDiv>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>7)</LegalOrderingDiv>
            <LegalBodyDiv multiply={1}>
              <span>
                {trans(
                  'Hazardous or poisonous goods;',
                  'สิ่งโสโครกหรือสิ่งมีพิษซึ่งอาจทำให้เกิดอันตราย'
                )}
              </span>
            </LegalBodyDiv>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>8)</LegalOrderingDiv>
            <LegalBodyDiv multiply={1}>
              <span>
                {trans(
                  'Fake or Infringement items;',
                  'สิ่งของปลอมแปลงหรือลอกเลียนแบบโดยละเมิดลิขสิทธิ์'
                )}
              </span>
            </LegalBodyDiv>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>9)</LegalOrderingDiv>
            <LegalBodyDiv multiply={1}>
              <span>
                {trans(
                  'Items that are illegal under applicable laws and regulations, contrary to public order, good morals, or defamatory or undermine the stability of religion and monarchy of the Thai nation; and',
                  'สิ่งอื่นใดอันผิดกฎหมาย หรือขัดต่อศีลธรรมอันดีของประชาชนชาวไทย หรือที่สร้างความเสื่อมเสีย หรือทำลายความมั่นคง ต่อประเทศชาติ ศาสนา และ สถาบันพระมหากษัตริย์'
                )}
              </span>
            </LegalBodyDiv>
          </LegalStyleDiv>

          <LegalStyleDiv>
            <LegalOrderingDiv>10)</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `Prohibited or unacceptable items under the Courier's shipment policies and items that are oversize or overweight as specified by the Courier.`,
                  'สิ่งอื่นใดที่เป็นพัสดุต้องห้ามหรือเป็นพัสดุที่ไม่รับขนส่งตามนโยบายของผู้ให้บริการขนส่ง หรือพัสดุที่มีขนาดหรือน้ำหนักเกินกว่าที่ผู้ให้บริการขนส่งกำหนด'
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <p>
            <span>
              {trans(
                'The Service Provider may, without prior notice, amend the list of prohibited items through this website,  application, or any other method, as it thinks fit, from time to time. The User is obligated to check that his/her delivered materials are not the prohibited item set out above. If it is found that the shipment contained the prohibited items, the Service Provider shall not be liable for any damages and the User will be solely responsible for all damages.',
                'กรณีที่มีการเปลี่ยนแปลงรายการพัสดุข้างต้นนั้น ผู้ให้บริการจะแจ้งให้ทราบเพิ่มเติมทางเว็บไซต์หรือช่องทางอื่นโดยมิต้องแจ้งให้ทราบล่วงหน้า และผู้ใช้บริการมีหน้าที่ตรวจสอบว่าพัสดุใด ๆ เป็นสิ่งของที่ผู้ให้บริการขอสงวนสิทธิ์ไม่ให้บริการ หากมีการใช้บริการสำหรับพัสดุข้างต้น ผู้ให้บริการจะไม่รับผิดชอบใด ๆ ทั้งสิ้นและผู้ใช้บริการตกลงเป็นผู้รับผิดชอบในความเสียหายที่เกิดขึ้นทั้งหมดแต่เพียงผู้เดียว'
              )}
            </span>
          </p>
        </li>

        <li>
          <span className={classes.strongStyle}>
            {trans('Eligibility', 'คุณสมบัติผู้ใช้บริการ')}
          </span>
          <p>
            {trans(
              'To be eligible to use the Services, the User must be capable of entering into and performing legally binding contracts under Thai laws. If the User is non-sui juris and incapable of performing legally binding contracts under Thai laws, the parent or guardian of the User must create an account and agree to these Terms on behalf of the User who is under your supervision. The Services are not available to the User if all the aforementioned conditions are not met.',
              'ผู้ใช้บริการจะต้องมีความสามารถในการเข้าทำนิติกรรมและสามารถปฏิบัติตามเงื่อนไขการใช้บริการนี้ภายใต้กฎหมายไทย ในกรณีที่ผู้ใช้บริการยังไม่บรรลุนิติภาวะและไม่มีความสามารถในการเข้าทำนิติกรรม บิดามารดาหรือผู้ปกครองของผู้ใช้บริการจะต้องยอมรับตามเงื่อนไขการใช้บริการนี้ก่อนรับบริการ ให้ความยินยอมแก่ผู้เยาว์ รวมทั้งสมัครสมาชิกและใช้บริการในนามของผู้เยาว์ซึ่งอยู่ในความปกครอง โดยท่านรับรองว่าท่านเป็นบิดามารดาหรือผู้ปกครองโดยชอบด้วยกฎหมายของผู้เยาว์จริงและผู้เยาว์ดังกล่าวอยู่ในความปกครองของท่าน ในกรณีที่ผู้ใช้บริการไม่มีคุณสมบัติข้างต้นผู้ให้บริการขอสงวนสิทธิ์ที่จะไม่ให้บริการ'
            )}
          </p>
        </li>

        <li>
          <span className={classes.strongStyle}>
            {trans('Creating Account', 'การสมัครสมาชิกของผู้ใช้บริการ')}
          </span>
          <LegalStyleDiv>
            <LegalOrderingDiv>4.1</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `To completely use the Services, the User may register an account on this website or application.`,
                  'เพื่อให้ผู้ใช้บริการสามารถใช้บริการได้อย่างครบถ้วนและมีประสิทธิภาพ ผู้ใช้บริการสามารถสมัครเข้าเป็นสมาชิกของผู้ให้บริการได้ผ่านทางเว็บไซต์หรือแอปพลิเคชันนี้'
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>4.2</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `The User may create an account by registering his/her Facebook ID or email. In order to create an account by using your email, the User must provide the Service Provider with certain information, including name, surname, phone number, email, and password, as well as verify identity via e-mail.`,
                  'ผู้ใช้บริการอาจสมัครสมาชิกผ่าน Facebook โดยยืนยันการขอใช้งาน หรือสมัครสมาชิกผ่านอีเมล ซึ่งผู้ใช้บริการจะต้องกรอกข้อมูลต่าง ๆ ซึ่งได้แก่ ชื่อ-นามสกุล เบอร์โทรศัพท์ติดต่อ อีเมล และรหัสผ่าน รวมทั้งยืนยันตัวตนผ่านทางอีเมล โดยเมื่อการลงสมัครสมาชิกเรียบร้อยแล้ว ระบบจะทำการสร้างบัญชีผู้ใช้เพื่อให้ท่านสามารถเข้าใช้บริการได้อย่างครบถ้วน'
                )}
              </span>
            </div>
          </LegalStyleDiv>

          <LegalStyleDiv>
            <LegalOrderingDiv>4.3</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `For providing accurate Services to the User, the User represents and warrants that all information provided by the User is true, accurate, complete, up-to-date, and not misleading. If the information changes, the User may update the information in the settings menu by selecting “Edit personal information”.`,
                  `ผู้ใช้บริการตกลงรับรองว่าข้อมูลต่าง ๆ ที่ผู้ใช้บริการแจ้งในการสมัครสมาชิกนั้นเป็นข้อมูลที่ถูกต้อง ครบถ้วน เป็นปัจจุบัน และไม่ก่อให้เกิดความเข้าใจผิด ในกรณีที่ข้อมูลมีการเปลี่ยนแปลง ผู้ใช้บริการสามารถแก้ไขข้อมูลได้ที่เมนูการตั้งค่าและเลือก “แก้ไขข้อมูลส่วนตัว” เพื่อให้ผู้ให้บริการให้บริการได้อย่างถูกต้อง`
                )}
              </span>
            </div>
          </LegalStyleDiv>

          <LegalStyleDiv>
            <LegalOrderingDiv>4.4</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `Upon successful registration, the User must not share or transfer the Identification Code and the account with anyone. The User must be responsible for all activities that occur under your account. If a third party uses the account and causes damage or loss to anyone, the Service Provider will not be responsible for such damage or loss in any way.`,
                  'เมื่อสร้างบัญชีผู้ใช้เรียบร้อยแล้ว ผู้ใช้บริการจะต้องไม่เปิดเผยรหัสประจำตัวหรืออนุญาตให้ผู้อื่นใช้บัญชีผู้ใช้ของผู้ใช้บริการ หากผู้ใช้บริการเปิดเผยรหัสส่วนตัวหรืออนุญาตให้บุคคลอื่นใช้บัญชีผู้ใช้ของตน ผู้ให้บริการจะถือว่าการปฏิบัติของบุคคลภายนอกดังกล่าวคือการปฏิบัติของผู้ใช้บริการ และหากการปฏิบัติของบุคคลดังกล่าวก่อให้เกิดความเสียหายหรือการเสียผลประโยชน์แก่บุคคลใด ๆ ผู้ให้บริการจะไม่รับผิดชอบทั้งสิ้น'
                )}
              </span>
            </div>
          </LegalStyleDiv>
        </li>

        <li>
          <p>
            <span className={classes.strongStyle}>
              {trans('Using the Services', 'การใช้บริการ')}
            </span>
          </p>
          <LegalStyleDiv>
            <LegalOrderingDiv>5.1</LegalOrderingDiv>
            <LegalBodyDiv multiply={1}>
              <span>
                {trans(
                  `The User must understand and agree with these Terms, the Privacy Policy, and the service policy of the Courier before registering an account or using the Services.`,
                  `ก่อนการสมัครสมาชิกหรือการใช้บริการของผู้ให้บริการนั้น ผู้ใช้บริการต้องเข้าใจและยอมรับข้อตกลง เงื่อนไขการใช้บริการ และนโยบายความเป็นส่วนตัวต่างๆของผู้ให้บริการทั้งหมด รวมถึงนโยบายการให้บริการของผู้ให้บริการขนส่งที่ผู้ใช้บริการเลือกก่อน`
                )}
              </span>
            </LegalBodyDiv>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>5.2</LegalOrderingDiv>
            <LegalBodyDiv multiply={1}>
              <span>
                {trans(
                  `The User must provide accurate, complete, current, and true information in all respects to the Service Provider, as well as verify his/her identity according to the procedures prescribed by the Service Provider. Any provided information is assumed to be correct, complete, and lawful. The Service Provider may, in some circumstances, require additional documents to verify any provided Information at any time, and the User agrees to comply with such request. If any provided Information is inaccurate, the User accepts to pay the Service Provider the actual Service Fees or expenses. The Service Provider shall have no responsibility for any mistake arising from any inaccurate information.`,
                  `ผู้ใช้บริการต้องให้ข้อมูลที่ถูกต้อง ครบถ้วน เป็นปัจจุบันและเป็นจริงทุกประการแก่ผู้ให้บริการ รวมทั้งยืนยันตัวตนตามวิธีการที่ให้บริการกำหนด เพื่อประโยชน์ในการให้บริการและการปฏิบัติตามกฎหมายที่เกี่ยวข้อง การกรอกข้อมูลใด ๆ โดยผู้ใช้บริการจะถือว่าผู้ใช้บริการได้ให้คำรับรองว่าข้อมูลดังกล่าวถูกต้อง ครบถ้วน และชอบด้วยกฎหมาย ในบางกรณีผู้ให้บริการอาจร้องขอเอกสารเพิ่มเติมเพื่อยืนยันข้อมูลต่าง ๆ และผู้ใช้บริการยอมรับที่ต้องปฏิบัติตามคำร้องขอ ทั้งนี้ หากตรวจสอบแล้วพบว่ามีการให้ข้อมูลไม่ถูกต้อง ผู้ใช้บริการยินยอมให้ผู้ให้บริการเรียกเก็บเงินส่วนต่างจากผู้ใช้บริการในภายหลังได้ตามจริงและผู้ให้บริการจะไม่รับผิดในความเสียหายใด ๆ ที่เกิดจากข้อมูลที่ไม่ถูกต้อง`
                )}
              </span>
            </LegalBodyDiv>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>5.3</LegalOrderingDiv>
            <LegalBodyDiv multiply={1}>
              <span>
                {trans(
                  `The Couriers selected by the User cannot be modified. However, subject to the Courier’s policy, the User may modify the Information related to the destination address or the consignee’s phone number by contacting our customer service.`,
                  `ในกรณีที่ข้อมูลเกี่ยวกับบริการขนส่งเปลี่ยนแปลงไป ผู้ใช้บริการจะไม่สามารถแก้ไขหรือเปลี่ยนแปลงผู้ให้บริการขนส่งที่เลือกได้ แต่ผู้ใช้บริการยังสามารถแก้ไขข้อมูลที่อยู่ปลายทาง หรือเบอร์โทรปลายทางได้ในบางกรณีโดยติดต่อผ่านฝ่ายบริการลูกค้าของผู้ให้บริการ ทั้งนี้ เงื่อนไขและรายละเอียดการแก้ไขข้อมูลขึ้นอยู่กับผู้ให้บริการขนส่งที่เลือก `
                )}
              </span>
            </LegalBodyDiv>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>5.4</LegalOrderingDiv>
            <LegalBodyDiv multiply={1}>
              <span>
                {trans(
                  `The User must not import or export any data and/or document from our websites or applications in a manner that is likely to cause damage to devices, hardware, or software, whether it is illegal or not.`,
                  `ผู้ให้บริการไม่อนุญาตให้นำเข้าและ/หรือส่งออกซึ่งข้อมูลใด ๆ และ หรือเอกสารใด ๆเข้ามาในเว็บไซต์หรือแอปพลิเคชันโดยประการที่อาจทำให้เกิดความเสียหายแก่อุปกรณ์ ฮาร์ดแวร์ หรือซอฟท์แวร์ไม่ว่าจะเป็นความผิดตามกฎหมายหรือไม่`
                )}
              </span>
            </LegalBodyDiv>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>5.5</LegalOrderingDiv>
            <LegalBodyDiv multiply={1}>
              <span>
                {trans(
                  `The User must not attempt or act to disrupt or interfere with our computer and network systems or conduct any illegal activity.`,
                  `ผู้ใช้บริการต้องไม่พยายามหรือกระทำการใด ๆ ที่เป็นอันตรายต่อความปลอดภัยของระบบคอมพิวเตอร์หรือระบบเน็ตเวิร์ค ซึ่งหมายรวมถึงการกระทำผิดใด ๆ ตามที่กฎหมายกำหนด`
                )}
              </span>
            </LegalBodyDiv>
          </LegalStyleDiv>

          <LegalStyleDiv>
            <LegalOrderingDiv>5.6</LegalOrderingDiv>
            <LegalBodyDiv multiply={1}>
              <span>
                {trans(
                  `The User is not permitted to transfer any of his/her rights or obligations under these Terms to anyone else.`,
                  `ผู้ให้บริการไม่อนุญาตให้ผู้ใช้บริการโอนสิทธิและหน้าที่ภายใต้ข้อตกลง เงื่อนไขการใช้บริการ และนโยบายความเป็นส่วนตัวแก่บุคคลและหรือนิติบุคคลอื่นโดยเด็ดขาด`
                )}
              </span>
            </LegalBodyDiv>
          </LegalStyleDiv>

          <LegalStyleDiv>
            <LegalOrderingDiv>5.7</LegalOrderingDiv>
            <LegalBodyDiv multiply={1}>
              <span>
                {trans(
                  `In order to use some Services, the Users may be required to enter into additional contracts or agreements.`,
                  `ในการใช้บริการบางประเภท ผู้ใช้บริการอาจต้องตกลงทำสัญญาหรือข้อตกลงอื่นใดเพิ่มเติมเพื่อใช้บริการนั้น ๆ`
                )}
              </span>
            </LegalBodyDiv>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>5.8</LegalOrderingDiv>
            <LegalBodyDiv multiply={1}>
              <span>
                {trans(
                  `The User agrees to be responsible for all activities that are done in accordance with these Terms in all respects or are done upon the User’s request.`,
                  `บรรดาการใด ๆ ที่ผู้ให้บริการได้กระทำไปตามเงื่อนไขการใช้บริการ และ/หรือ ตามข้อมูลหรือตามคำร้องขอที่ผู้ใช้บริการซึ่งได้แจ้งต่อผู้ให้บริการหรือตัวแทนให้มีผลผูกพันผู้ใช้บริการทุกประการ`
                )}
              </span>
            </LegalBodyDiv>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>5.9</LegalOrderingDiv>
            <LegalBodyDiv multiply={1}>
              <span>
                {trans(
                  `The User must not use the Services in any manner that violates these Terms, laws, regulations, public morals, or in any abnormal manners that will likely cause damages to any person. If the User uses the Services in a fraudulent manner, the Service Provider reserves the rights to (a) suspend the Services provided to the User; (b) forfeit the Service Fees; and (c) claim any damages from the User.`,
                  `ผู้ใช้บริการจะไม่ใช้บริการนี้เพื่อวัตถุประสงค์ที่ขัดต่อเงื่อนไขการใช้บริการ กฎหมาย ศีลธรรมหรือข้อบังคับอื่น ๆ หรือก่อให้เกิดความเสียหายแก่บุคคลใด ๆและจะต้องปฏิบัติตามกฎหมายหรือกฎระเบียบต่าง ๆ ในกรณีที่มีการใช้บริการเพื่อส่งพัสดุในลักษณะฉ้อฉลบุคคลอื่น ผู้ให้บริการขอสงวนสิทธิ์ระงับการใช้งานของผู้ใช้บริการนั้น รวมทั้งริบเงินค่าบริการและเรียกค่าเสียหายใด ๆ จากผู้ใช้บริการนั้นได้ตามสมควร`
                )}
              </span>
            </LegalBodyDiv>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>5.10</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `The User warrants that he/she owns or possesses the lawful right of any delivered item.`,
                  `ผู้ใช้บริการรับรองว่าตนเป็นเจ้าของหรือมีสิทธิในสิ่งของที่ใช้บริการนี้โดยชอบด้วยกฎหมาย`
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>5.11</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `The User is responsible for ensuring that delivered items are contained in proper packaging and safe for shipment. In the event that such items cause damage to any property or person, the User agrees to be responsible for all damage and expenses arising from such items.`,
                  `ผู้ใช้บริการตกลงจัดเตรียมและบรรจุสิ่งของอย่างปลอดภัยและเหมาะสมต่อการขนส่ง ในกรณีที่พัสดุก่อให้เกิดความเสียหายต่อทรัพย์สินหรือบุคคลใด ๆ ผู้ใช้บริการจะเป็นผู้รับผิดชอบความเสียหายและค่าใช้จ่ายทั้งหมด`
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>5.12</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `The duration of the User’s shipment shown on this website or application is an estimated time and may be changed or postponed due to the Courier, force majeure, or unfavorable weather conditions. Therefore, the Service Provider cannot guarantee the shown duration of the Service and the shown duration of the Services must not blind the Service Provider. The Service Provider will not reliable for any loss or damage arising from delayed shipment.`,
                  `ระยะเวลาการบริการที่แสดงเป็นระยะเวลาที่ถูกประมาณการและอาจมีการเปลี่ยนแปลงหรือล่าช้ากว่าที่กำหนด เนื่องจากผู้ให้บริการขนส่ง เหตุสุดวิสัย หรือสภาพอากาศที่ไม่เอื้ออำนวยต่อการให้บริการ โดยผู้ให้บริการไม่อาจรับประกันระยะเวลาการบริการดังกล่าวได้และระยะเวลานั้นไม่ถือเป็นข้อผูกพันผู้ให้บริการ โดยผู้ให้บริการจะไม่รับผิดชอบต่อการสูญหาย หรือความเสียหายใด ๆ ทั้งสิ้นที่เกิดจากความล่าช้า`
                )}
              </span>
            </div>
          </LegalStyleDiv>

          <LegalStyleDiv>
            <LegalOrderingDiv>5.13</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `The User agrees to fully compensate the Service Provider, the Courier, or any other person for any loss and damage incurred from breach of these Terms.`,
                  `ผู้ใช้บริการยินยอมรับผิดเต็มจำนวนสำหรับความสูญเสียและความเสียหายที่เกิดขึ้นกับผู้ให้บริการ ผู้ให้บริการขนส่งหรือบุคคลอื่นใดจากการฝ่าฝืนเงื่อนไขการใช้บริการนี้`
                )}
              </span>
            </div>
          </LegalStyleDiv>

          <LegalStyleDiv>
            <LegalOrderingDiv>5.14</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `We and the Courier reserve the right to open and inspect any delivered packaging without prior notice to the User for safety, security, customs, or regulatory reasons.`,
                  `ผู้ให้บริการหรือผู้ให้บริการขนส่งมีสิทธิในการเปิดตรวจสอบสิ่งจัดส่งโดยไม่ต้องแจ้งให้ผู้ใช้บริการทราบ ด้วยเหตุผลเรื่องความปลอดภัย การปฏิบัติกฎหมาย กระบวนการศุลกากรหรือเหตุผลที่ชอบอื่น`
                )}
              </span>
            </div>
          </LegalStyleDiv>
        </li>

        <li>
          <p>
            <span className={classes.strongStyle}>
              {trans(
                'Additional Terms of COD Service',
                'เงื่อนไขการใช้บริการเพิ่มเติมสำหรับบริการเก็บเงินปลายทาง (COD)'
              )}
            </span>
          </p>
          <LegalStyleDiv>
            <LegalOrderingDiv>6.1</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `Before using the COD service, the User must verify his/her identity according to the procedures prescribed by the Service Provider and provide correct and complete bank account information. The name of the provided bank account must match with the name on the registered ID card.`,
                  `ก่อนการใช้บริการเก็บเงินปลายทาง (COD) ผู้ใช้บริการจะต้องดำเนินการยืนยันตัวตนตามวิธีการที่ผู้ให้บริการกำหนดและกรอกข้อมูลบัญชีธนาคารของผู้ใช้บริการให้ถูกต้องและครบถ้วน โดยชื่อบัญชีธนาคารของผู้ใช้บริการจะต้องตรงกับชื่อบนบัตรประชาชนที่ได้ทำการลงทะเบียนในระบบ`
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>6.2</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `The COD will be available to the User only after we have completely checked the documents prescribed in Clause 6.1.`,
                  `ผู้ใช้บริการจะใช้บริการเก็บเงินปลายทาง (COD) ได้ก็ต่อเมื่อผู้ให้บริการได้ตรวจสอบเอกสารตามข้อ 6.1 เรียบร้อยแล้ว`
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>6.3</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `The COD amount will be transferred only through the provided bank account.`,
                  `ผู้ให้บริการจะดำเนินการโอนเงินค่าสินค้าผ่านบัญชีธนาคารที่ผู้ใช้บริการได้แจ้งให้ทราบเท่านั้นและภายใต้เงื่อนไขที่ผู้ให้บริการได้กำหนดและแจ้งให้ผู้ใช้บริการทราบ`
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>6.3</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `By using the COD service, the User warrants that the User has informed the actual value of the goods to the Service Provider. The User acknowledges that the COD amount may be deducted by the Service Fees, surcharges, or taxes.`,
                  `ผู้ใช้บริการรับรองว่าได้แจ้งมูลค่าที่แท้จริงของสินค้าให้แก่ผู้ให้บริการ และผู้ใช้บริการตกลงให้ผู้ให้บริการหักค่าธรรมเนียมในการให้บริการซึ่งคำนวณจากมูลค่าสินค้าตามอัตราที่กำหนด ค่าธรรมเนียมอื่น ๆ และภาษีก่อนโอนเงินค่าสินค้าคืนให้กับผู้ใช้บริการ`
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>6.5</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `The Service Provider shall not be liable for any damage, if a consignee opens or damages delivered goods by oneself, or in case of non-payment.`,
                  `ในกรณีที่ผู้รับปลายทางเปิดหรือทำให้สินค้าเสียหายหรือไม่สามารถเรียกเก็บเงินได้เนื่องจากการกระทำของผู้รับปลายทาง ผู้ให้บริการจะไม่รับผิดชอบต่อความเสียหายของสินค้าหรือการเรียกเก็บค่าสินค้า`
                )}
              </span>
            </div>
          </LegalStyleDiv>
        </li>

        <li>
          <p>
            <span className={classes.strongStyle}>
              {trans(
                'Additional Terms of SHIPPOP PRO',
                'เงื่อนไขการใช้บริการเพิ่มเติมสำหรับบริการ SHIPPOP PRO'
              )}
            </span>
          </p>
          <LegalStyleDiv>
            <LegalOrderingDiv>7.1</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `The SHIPPOP PRO Service is only available for the User who delivers at least 1,000 parcels per month and continuously uses the SHIPPOP PRO Service every month. By using this service, the weight or measurements of delivered parcels will not be required and the Service Fees will be charged based on actual usage. This service is also available by connecting to the API. However, in case the number of delivered parcels is less than 1,000, the User will be charged with the membership fee at the prescribed rate.`,
                  `บริการ SHIPPOP PRO เป็นบริการสำหรับผู้ใช้บริการที่มียอดขั้นต่ำในการจัดส่งพัสดุไม่ต่ำกว่า 1,000 ชิ้นต่อเดือนและมีการใช้งานอย่างต่อเนื่องตลอดทุกเดือน โดยผู้ใช้บริการไม่ต้องกรอกน้ำหนักและขนาดของพัสดุ โดยค่าบริการจะถูกชำระตามที่ใช้งานจริงเท่านั้น หรือหากผู้ใช้บริการมีเว็บไซต์ ผู้ใช้บริการจะสามารถใช้งานผ่านการเชื่อมต่อระบบ API ได้ทันที ในกรณีที่ผู้ใช้บริการมียอดจัดส่งพัสดุน้อยกว่า 1,000 ชิ้นจะมีค่าสมัครสมาชิกเป็นรายเดือน`
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>7.2</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `To use SHIPPOP PRO Service, the User must first enter all required information on the website, then apply for the service through the sales staff of Shippop Co., Ltd. only.`,
                  `การสมัครใช้บริการ SHIPPOP PRO ผู้ใช้บริการจะต้องกรอกข้อมูลผ่านเว็บไซต์และสมัครบริการผ่านพนักงานฝ่ายขายของบริษัท ชิปป๊อป จำกัด เท่านั้น`
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>7.3</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `The User may pay a shipment fee on a daily, weekly, or monthly basis, based on the consideration and criteria of the Service Provider.`,
                  `ผู้ใช้บริการสามารถเลือกการชำระเงินค่าขนส่งเป็นรอบรายวัน รอบรายสัปดาห์ หรือรอบรายเดือน ภายใต้การพิจารณาและหลักเกณฑ์ของผู้ให้บริการ`
                )}
              </span>
            </div>
          </LegalStyleDiv>
        </li>

        <li>
          <p>
            <span className={classes.strongStyle}>
              {trans('Service Fees and Payment', 'ค่าบริการและการชำระเงิน')}
            </span>
          </p>
          <LegalStyleDiv>
            <LegalOrderingDiv>8.1</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `The Service Fees shown on this website or application are initial fees that are calculated based on the distance, size, and weight information provided by the User. If the Service Provider acknowledges that such provided information is incorrectly, the actual fee will be charged to the User. The Service Provider reserves the right to change the rates of the Service Fees without notifying the User in advance.`,
                  `ค่าบริการที่แสดงบนเว็บไซต์หรือแอปพลิเคชันนี้เป็นค่าบริการเบื้องต้นซึ่งคำนวณตามระยะทาง ขนาด และน้ำหนักที่ผู้ใช้บริการเป็นผู้กรอกข้อมูล หากตรวจสอบแล้วพบว่ามีการระบุระยะทาง ขนาดหรือน้ำหนักไม่ถูกต้อง ผู้ให้บริการสามารถเรียกเก็บเงินส่วนต่างภายหลังได้ตามจริง ทั้งนี้ ผู้ให้บริการขอสงวนสิทธิ์ในการเปลี่ยนแปลงค่าบริการโดยมิต้องแจ้งให้ผู้ใช้บริการทราบล่วงหน้า`
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>8.2</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `The User agrees to be responsible for any Service Fees or expenses incurred from the use of the Services, even if the User inputs or transmits fault information. The service payment and service rates shall be subject to the policies set by the Service Provider at that time.`,
                  `ผู้ใช้บริการตกลงรับผิดชอบในค่าบริการหรือค่าใช้จ่ายต่าง ๆ ที่เกิดขึ้นจากการให้บริการนี้ที่มีการเรียกเก็บค่าใช้จ่าย แม้ต่อมาจะปรากฏว่ามีความผิดพลาดที่เกิดขึ้นจากการป้อนข้อมูลหรือส่งข้อมูลจากผู้ใช้บริการ สำหรับเงื่อนไขการชำระเงินค่าบริการและอัตราค่าบริการให้เป็นไปตามนโยบายที่ผู้ให้บริการกำหนดในขณะนั้น`
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>8.3</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `The User allows the Service Provider to use and disclose his/her personal data for the purpose of payment.`,
                  `ภายใต้นโยบายความเป็นส่วนตัวของผู้ให้บริการ ผู้ใช้บริการตกลงให้ผู้ให้บริการดำเนินการเรียกเก็บเงินและเปิดเผยข้อมูลส่วนบุคคลให้กับสถาบันการเงินหรือผู้ให้บริการที่ดำเนินการชำระเงินซึ่งเป็นบุคคลที่สาม เพื่อดำเนินการชำระเงิน`
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>8.4</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `Unless otherwise prescribed in These Terms, the User acknowledges and accepts that the Service Provider will not refund the Service Fee and other expenses if the parcel has been processed into the system or the Services have been delivered.`,
                  `ผู้ใช้บริการรับทราบและตกลงว่าผู้ให้บริการจะไม่คืนเงินค่าบริการและค่าใช้จ่ายต่าง ๆ ทุกกรณีเมื่อมีการนำพัสดุเข้าสู่ระบบของผู้ให้บริการหรือมีการให้บริการเรียบร้อยแล้ว เว้นแต่เป็นกรณีที่กำหนดไว้ในเงื่อนไขการใช้บริการฉบับนี้`
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>8.5</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `Payments made by bank transfer or online method will be deemed to be completed, if the Service Provider has received proof of payment.`,
                  `ในการชำระเงินผ่านการโอนเงินผ่านบัญชีธนาคารหรือการชำระเงินผ่านระบบออนไลน์ จะถือว่าการชำระเงินนั้นเสร็จสมบูรณ์ เมื่อผู้ให้บริการได้รับหลักฐานการชำระเงินและทำการตรวจสอบได้เรียบร้อยแล้ว`
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>8.6</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `The Service Provider reserves the right to restore the Services. In the event that the User cancels the Services or cuts down the Service before the end of the contract. The user has no right to refund the Service Fee in any circumstance, unless the Service Provider found it reasonable to refund the Service Fee. If there is a violation in the agreement, the Service Provider shall have the right to notify the User and terminate the contract. If there isn’t any improvement and the action affects the system, network, or reputation of the Service Provider, the User shall be solely responsible for all damages that occur.`,
                  `ผู้ให้บริการขอสงวนสิทธิ์ในการคืนเงินใด ๆ ในกรณีที่ผู้ใช้ต้องการยกเลิกใช้บริการหรือปรับลดบริการลงก่อนครบกำหนดสัญญา (ถ้ามี) และผู้ใช้บริการไม่มีสิทธิ์เรียกค่าบริการใด ๆ คืนไม่ว่าบางส่วนหรือทั้งหมดได้ เว้นแต่ทางผู้ให้บริการจะเป็นผู้ยกเลิกบริการเอง โดยผู้ให้บริการจะคืนค่าบริการตามสมควรให้เท่านั้น หากมีการละเมิดข้อตกลงดังกล่าวผู้ให้บริการจะแจ้งเตือน และจะหยุดให้บริการ หากผู้ใช้บริการไม่ทำการแก้ไขให้ถูกต้อง และการกระทำของผู้ใช้บริการเป็นการกระทำที่ส่งผลกระทบต่อ ระบบ เครือข่าย และชื่อเสียงของผู้ให้บริการ ผู้ใช้บริการจะต้องรับผิดชอบความเสียหายที่เกิดขึ้นทั้งหมด `
                )}
              </span>
            </div>
          </LegalStyleDiv>
        </li>

        <li>
          <p>
            <span className={classes.strongStyle}>
              {trans('Personal Data Protection', 'การคุ้มครองข้อมูลส่วนบุคคล')}
            </span>
          </p>
          <LegalStyleDiv>
            <LegalOrderingDiv>9.1</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `Before using the Services, please carefully read the detail of our Privacy Policy at https://www.shippop.com/en/privacy.`,
                  `ก่อนตัดสินใจใช้บริการนี้ ผู้ใช้บริการต้องศึกษานโยบายความเป็นส่วนตัวตามที่ปรากฏใน  https://www.shippop.com/privacy`
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>9.2</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `The User’s personal data will be kept confidential, except as follows;`,
                  `ข้อมูลส่วนบุคคลของผู้ใช้บริการจะไม่ถูกเปิดเผยให้แก่บุคคลภายนอก เว้นแต่`
                )}
              </span>
              <ol style={{ listStyleType: 'none' }}>
                <li>
                  <LegalStyleDiv>
                    <LegalOrderingDiv>1)</LegalOrderingDiv>
                    <div>
                      <span>
                        {trans(
                          `in case we obtained the consent from the User;`,
                          `ได้รับความยินยอมจากผู้ใช้บริการ`
                        )}
                      </span>
                    </div>
                  </LegalStyleDiv>
                </li>
                <li>
                  <LegalStyleDiv>
                    <LegalOrderingDiv>2)</LegalOrderingDiv>
                    <div>
                      <span>
                        {trans(
                          `in case we are required by laws or court order; or `,
                          `กระทำการตามที่กฎหมายบังคับและ/หรือตามคำสั่งหรือหมายของศาล `
                        )}
                      </span>
                    </div>
                  </LegalStyleDiv>
                </li>
                <li>
                  <LegalStyleDiv>
                    <LegalOrderingDiv>3)</LegalOrderingDiv>
                    <div>
                      <span>
                        {trans(
                          `in case of processing of personal subject to our Privacy Policy.`,
                          `เป็นไปตามนโยบายความเป็นส่วนตัว`
                        )}
                      </span>
                    </div>
                  </LegalStyleDiv>
                </li>
              </ol>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>9.3</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `Under laws, these Terms, and the Privacy Policy, the Service Provider may, without prior notice, use any information provided by the User, including personal data, for research, analysis, differentiation, or any other purpose as the Service Provider deems appropriate.`,
                  `ภายใต้กฎหมาย เงื่อนไขการใช้บริการ และนโยบายความเป็นส่วนตัว ผู้ให้บริการสามารถนำข้อมูลใด ๆ ก็ตามที่ผู้ใช้บริการให้กับผู้ให้บริการผ่านช่องทางต่าง ๆ ไปใช้ในการวิจัย วิเคราะห์ แยกแยะ หรือวัตถุประสงค์อื่นใดตามที่เห็นสมควร โดยมิต้องแจ้งให้ทราบล่วงหน้าไม่ว่าข้อมูลดังกล่าวจะเป็นข้อมูลส่วนบุคคลหรือไม่`
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>9.4</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `The User agrees that the Service Provider can collect, update, share, disclose, process, and uses his/her personal data for the benefit of providing the Services and provide convenience to the User.`,
                  `ผู้ใช้บริการตกลงให้ผู้ให้บริการรวบรวม อัพเดท แบ่งปัน เปิดเผย ประมวลผล และใช้ข้อมูลส่วนบุคคลเพื่อประโยชน์ในการให้บริการและอำนวยความสะดวกแก่ผู้ใช้บริการ`
                )}
              </span>
            </div>
          </LegalStyleDiv>
        </li>

        <li>
          <p>
            <span className={classes.strongStyle}>
              {trans(
                'Intellectual Property and Trademark',
                'ทรัพย์สินทางปัญญาและเครื่องหมายการค้า'
              )}
            </span>
          </p>
          <p>
            {trans(
              'The Service Provider owns all rights, titles, and interests in any and all contents, trademarks, copyrights, patent rights, and other intellectual property or other rights in the information, material, as well as any design of the Services, this website or application. Unless otherwise agreed in these Terms or other agreements, the User ​​must not copy, decompile, reverse engineer, decode, distribute or decrypt any material of the Service, or any content available on this website or application',
              'ผู้ให้บริการเป็นเจ้าของหรือมีซึ่งสิทธิในเนื้อหาและเครื่องหมายการค้า รวมทั้งลิขสิทธิ์ สิทธิบัตร และทรัพย์สินทางปัญญาในข้อมูลที่แสดง รูปภาพ และ รูปแบบการแสดงผลตามที่ปรากฏในบริการ เว็บไซต์หรือแอปพลิเคชันทั้งหมด ห้ามมิให้ผู้ใดทำการคัดลอก ทำซ้ำ มีสำเนา สำรองไว้ ทำเลียนแบบ ทำเหมือน ดัดแปลง ทำเพิ่ม เพื่อนำไปเผยแพร่ด้วยวัตถุประสงค์อื่นใด โดยปราศจากความยินยอมเป็นหนังสือจากผู้ให้บริการ ทั้งนี้เว้นแต่จะได้มีการระบุกำหนดไว้ในข้อตกลง เงื่อนไขการใช้บริการ '
            )}
          </p>{' '}
        </li>

        <li>
          <p>
            <span className={classes.strongStyle}>
              {' '}
              {trans('Disclaimer', 'ความรับผิด')}
            </span>
          </p>
          <p>
            {trans(
              'The User acknowledges and agrees that:',
              'ผู้ใช้บริการทราบและตกลงตามข้อความดังนี้'
            )}
          </p>{' '}
          <LegalStyleDiv>
            <LegalOrderingDiv>11.1</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `The Service Provider shall not be liable for any damage incurred from the act or omission by the User, improper packaging, or the delivery of the parcel that does not comply with the requirements of the Courier. If the Service Provider is required to compensate the User for any damage, the liability will be limited to the actual value of loss or damage of the shipment, which not exceed 1,000 baht or other amounts as the Service Provider deems appropriate. The Service Provider shall not be liable to any person for indirect loss, punitive damages, loss of profits, damages from data loss or unavailability of the Services.`,
                  `ผู้ให้บริการไม่รับผิดชอบต่อความเสียหายใด ๆ ก็ตามที่เกิดจากความบกพร่องของผู้ใช้บริการหรือเกิดจากการบรรจุหรือห่อหุ้มสิ่งของไม่แข็งแรงหรือการขนส่งพัสดุที่ไม่เป็นไปตามข้อกำหนดของผู้ให้บริการขนส่ง หากผู้ให้บริการจำเป็นต้องชดใช้ค่าเสียหาย ผู้ให้บริการจะรับผิดต่อค่าเสียหายที่แท้จริงที่เกิดขึ้นโดยตรงไม่เกิน 1,000 บาทต่อพัสดุ หรือตามที่ผู้ให้บริการเห็นสมควรเท่านั้น โดยผู้ให้บริการจะไม่รับผิดต่อความเสียหายโดยทางอ้อม ค่าเสียหายเชิงลงโทษ การสูญเสียผลกำไร และ/หรือความเสียหายที่เป็นผลจากการสูญเสียข้อมูลที่เป็นผลจากการใช้งานและ/หรือการไม่สามารถใช้งานบริการต่อบุคคลใด ๆ`
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>11.2</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `If the User causes any damage to the Service Provider, whether intentionally or attempted to act, whether directly or indirectly, the Service Provider shall be entitled to claim for damages or file a lawsuit against the law.`,
                  `หากผู้ใช้บริการก่อให้เกิดความเสียหายใด ๆ ไม่ว่าจงใจกระทำการหรือพยายามกระทำการและไม่ว่าจะโดยตรงหรือโดยอ้อมอันจะทำให้ผู้ให้บริการได้รับความเสียหาย เสียชื่อเสียง หรือสิ่งใด ผู้ให้บริการมีสิทธิเรียกร้องค่าเสียหาย หรือฟ้องร้องดำเนินคดีตามกฎหมายได้`
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>11.3</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `The Service Provider and the User shall not be liable for their inability to perform their duties under these Terms, if the inability to perform such duties is caused by Force Majeure or any circumstance beyond their control.`,
                  `ผู้ให้บริการและผู้ใช้บริการจะไม่ต้องรับผิดในการไม่สามารถปฏิบัติหน้าที่ของตนภายใต้เงื่อนไขการใช้บริการนี้ ถ้าการไม่สามารถปฏิบัติหน้าที่ดังกล่าวเกิดจากเหตุสุดวิสัยหรือเหตุใดที่อยู่นอกเหนือการควบคุมของผู้ให้บริการหรือผู้ใช้บริการ `
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>11.4</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `The User shall not claim any damages from the Service Provider in the event that the damage is caused by (a) incorrect information; (b) failure of software, hardware, Internet, or electronic communication; (c) the User not comply with these Terms; (d) any event beyond the control of the Service Provider; (e) delivered items classified as fragile (such as glass, ceramics, wood, etc.), electrical and magnetic damage, obliteration of electronic materials, defects or any damages due to the nature of the delivered items (even if the Service Provider is notified of such incidents); and (f) any acts or omissions of the User or any other person that not employed or contracted with the Service Provider such as shippers, consignees, third parties, tax authorities, and other governmental authorities.`,
                  `ผู้ใช้บริการจะไม่เรียกร้องค่าเสียหายใดๆ จากผู้ให้บริการในกรณีที่ความเสียหายเกิดจาก (ก) การป้อนข้อมูลหรือส่งข้อมูลของผู้ใช้บริการไม่ถูกต้อง (ข) ซอฟต์แวร์ ฮาร์ดแวร์ อินเทอร์เน็ต หรือการสื่อสารทางอิเล็กทรอนิกส์ล้มเหลว (ค) การที่ผู้ใช้บริการไม่ปฏิบัติตามข้อกำหนดนี้  (ง) เหตุการณ์อื่นใดที่นอกเหนือความควบคุมของผู้ให้บริการ (จ) สินค้าที่จัดอยู่ในประเภทเสี่ยงแตกหักได้ง่าย เช่น แก้ว เซรามิก ไม้ และอื่นๆ รวมถึง ความเสียหายทางไฟฟ้าและแม่เหล็ก หรือการลบเลือนที่เกิดขึ้นกับภาพอิเล็กทรอนิกส์และภาพถ่าย ข้อมูล ข้อมูลบันทึกอัดเก็บ หรือความบกพร่องหรือความเสียหายลักษณะอื่นใดที่เกี่ยวข้องตามธรรมชาติของสิ่งของที่จัดส่งถึงแม้ว่าจะมีการแจ้งให้ผู้ให้บริการรับทราบถึงเหตุการณ์ดังกล่าวก็ตาม และ (ฉ) การกระทำหรือการละเว้นการกระทำของผู้ใช้บริการเองหรือบุคคลอื่นใดที่ไม่ได้รับการว่าจ้างหรือทำสัญญากับผู้ให้บริการ เช่น ผู้จัดส่ง ผู้รับ บุคคลที่สาม หน่วยงานภาษีอากรและหน่วยงานรัฐอื่น ๆ`
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>11.5</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `The Service Provider will not be liable for any penalty, loss, or damage incurred as a result of official authorities seizing the User's documents or items. The User hereby indemnifies the Service Provider against such penalty or loss that may incur.`,
                  `ผู้ให้บริการจะไม่รับผิดชอบต่อบทลงโทษใด ๆ ที่กำหนดหรือสูญเสียหรือความเสียหายที่เกิดขึ้นเนื่องจากเอกสารหรือสินค้าหรือพัสดุของผู้ใช้บริการที่ถูกยึดโดยหน่วยงานราชการ และผู้ใช้บริการชดใช้ค่าเสียหายหรือการสูญเสียที่อาจเกิดขึ้นกับผู้ให้บริการ`
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>11.6</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `In the event that the Service Provider already compensates the User under these Terms, the Service Provider shall be released from all liability for any loss and damage expressed herein. The User further agrees to waive any and all rights to claim against the Service Provider in all respect of such liability.`,
                  `ในกรณีที่ผู้ให้บริการรับผิดตามเงื่อนไขการใช้บริการนี้แล้ว ผู้ใช้บริการตกลงให้ผู้ให้บริการหลุดพ้นจากความรับผิดชอบทั้งหมดอย่างชัดเจนสำหรับการสูญเสียความเสียหายหรือการจัดการอื่น ๆ ของความรับผิดดังกล่าว และผู้ใช้บริการตกลงสละสิทธิเรียกร้องทั้งหมดที่มีต่อผู้ให้บริการในส่วนที่มีความเกี่ยวข้องกับความรับผิดดังกล่าว`
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>11.7</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `The Service Provider shall be only responsible for the shipment or the Services specified in the registration or the system.`,
                  `ผู้ให้บริการรับผิดชอบเฉพาะการจัดส่งหรือบริการซึ่งปรากฏชื่อผู้ใช้บริการเดียวกับผู้ใช้บริการตามที่ระบุไว้ในการลงทะเบียนหรือในระบบ`
                )}
              </span>
            </div>
          </LegalStyleDiv>
        </li>

        <li>
          <p>
            <span className={classes.strongStyle}>
              {trans(
                'Amendment, Suspension, Refusal, or Cancellation of the Services',
                'การเปลี่ยนแปลง ระงับ ปฏิเสธหรือยกเลิกการบริการ'
              )}
            </span>
          </p>
          <LegalStyleDiv>
            <LegalOrderingDiv>12.1</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `These Services are provided ‘AS IS’ and ‘AS AVAILABLE’. The Service Provider reserves the right to temporarily suspend or cancel these Services, even if the User does not breach these Terms or the Privacy Policy and the Service Provider will only refund the remaining amount of the actual Service Fee to the User.  The refund is subject to the terms of the service fee specified by the Service Provider. The User cannot claim any compensation other than the paid Service Fee.`,
                  `บริการนี้เป็นการให้บริการตามสภาพที่เป็นอยู่ (AS IS) และมีอยู่ (AS AVAILABLE) ผู้ให้บริการสามารถระงับหรือยกเลิกการให้บริการแก่ผู้ใช้บริการใดๆ ตามที่เห็นสมควรได้ ถึงแม้ว่าผู้ใช้บริการจะไม่ได้ละเมิดข้อตกลง เงื่อนไขการใช้การบริการ และนโยบายความเป็นส่วนตัวใด ๆ ก็ตาม โดยผู้ให้บริการจะคืนค่าบริการตามจริงเฉพาะที่ยังไม่ได้ใช้งานเท่านั้น ทั้งนี้ ให้เป็นไปตามเงื่อนไขของค่าบริการที่ผู้ให้บริการกำหนดไว้ และผู้ใช้บริการไม่สามารถเรียกร้องค่าเสียหายอื่น ๆ นอกเหนือจากค่าบริการที่ผู้ใช้บริการได้ชำระกับผู้ให้บริการแล้วเท่านั้น`
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>12.2</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `If the User does not log in to his/her account for a long time, the Service Provider may suspend the Services for the User without prior notice.`,
                  `ผู้ให้บริการสามารถระงับการให้บริการแก่ผู้ใช้บริการในกรณีที่ผู้ใช้บริการไม่เข้าสู่ระบบเป็นเวลานานโดยมิต้องแจ้งให้ทราบล่วงหน้า`
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>12.3</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `The Service Provider may temporarily suspend the Services due to some necessity, including Force majeure or any other event beyond the control of the Service Provider, the malfunction in equipment or software, communications failure or delay in operation, unavailability of the Services for system maintenance or improvement or other interferences that may affect the Services. The Service Provider reserves the right not to refund the Service fee for the period of the suspension of such service and the Service Provider shall have no liability due to such suspension in all respects.`,
                  `ผู้ให้บริการอาจระงับการให้บริการเป็นการชั่วคราวด้วยเหตุจำเป็นบางประการ ซึ่งรวมถึงเหตุสุดวิสัยหรือข้อบกพร่องที่ไม่สามารถคาดการณ์ได้ล่วงหน้า อันอาจจะเกิดจุดบกพร่องของอุปกรณ์ ซอฟต์แวร์ การปรับปรุงระบบหรือสิ่งอื่นใดที่มีผลกระทบต่อการใช้บริการและให้บริการ และในกรณีที่มีการระงับบริการประเภทที่มีค่าบริการ ขอสงวนสิทธิ์ในการไม่คืนค่าบริการสำหรับระยะเวลาที่ระงับบริการดังกล่าว และถือว่าผู้ให้บริการไม่มีความรับผิดในการระงับบริการดังกล่าวไม่ว่าประการใด`
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>12.4</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `The Service Provider may cease the Service provided to the User for the following reasons: (a) the User uses the Service for any illegal actions, obscene or fraudulent purpose, or for any prohibited purpose which is against lawห or regulationห; (b) the User's failure to pay any outstanding payments to the Service Provider on the due date; and (c) the User breach these Terms and other conditions of use.`,
                  `ผู้ให้บริการอาจยุติการให้บริการแก่ผู้ใช้บริการด้วยสาเหตุดังต่อไปนี้ (ก) การใช้บริการของเพื่อวัตถุประสงค์ที่ผิดกฎหมาย การลามกอนาจารหรือฉ้อโกงหรือเพื่อวัตถุประสงค์ที่ห้ามซึ่งผิดกฎหมาย ข้อบังคับหรือกฎระเบียบอื่น ๆ (ข) ความล้มเหลวของผู้ใช้บริการในการชำระเงินที่ค้างชำระกับผู้ให้บริการเมื่อถึงกำหนด และ (ค) การละเมิดข้อกำหนดและเงื่อนไขการใช้บริการใด ๆ เหล่านี้`
                )}
              </span>
            </div>
          </LegalStyleDiv>
        </li>

        <li>
          <p>
            <span className={classes.strongStyle}>
              {trans('Modification', 'การแก้ไขเปลี่ยนแปลง')}
            </span>
          </p>
          <p>
            {trans(
              'The Service Provider may, without prior notice, change these Terms or the Privacy Policy from time to time to reflect the Services and to comply with the laws. However, the User can check the updated Terms or Privacy through this website or application before using the Services. If the User disagrees with these Terms, please do not continue to use the Service. The continued use of the Services after changes become effective will mean that the User accepts those changes.',
              'ผู้ให้บริการสามารถเปลี่ยนแปลง ข้อตกลง เงื่อนไขการใช้บริการ นโยบายความเป็นส่วนตัว ข้อกำหนด สัญญา และหรือชื่ออื่นใดอันมีความหมายเช่นเดียวกันในการให้บริการได้โดยไม่จำเป็นต้องแจ้งให้ผู้ใช้บริการทราบล่วงหน้าเพื่อให้สอดคล้องกับการให้บริการในปัจจุบันและกฎหมาย โดยผู้ใช้บริการสามารถตรวจสอบการเปลี่ยนแปลงเงื่อนไขการใช้บริการได้ผ่านทางเว็บไซต์หรือแอปพลิเคชันนี้'
            )}
          </p>{' '}
          <p>
            {trans(
              '',
              'ทั้งนี้ โปรดยุติการใช้บริการของเราหากผู้ใช้บริการไม่ตกลงตามเงื่อนไขการใช้บริการที่เปลี่ยนแปลงการที่ผู้ใช้บริการเข้าใช้งานภายหลังการเปลี่ยนแปลงเงื่อนไขการใช้บริการจะถือว่าผู้ใช้บริการตกลงที่จะปฏิบัติตามเงื่อนไขการใช้บริการที่เปลี่ยนแปลงดังกล่าว '
            )}
          </p>{' '}
        </li>

        <li>
          <p>
            <span className={classes.strongStyle}>
              {trans(
                'Communication and Complaint Channels',
                'การติดต่อและการร้องเรียน'
              )}
            </span>
          </p>
          <p>
            {trans(
              'If the User has any questions or wishes to contact us, the User can contact us through cs@shippop.com, from Monday to Sunday, from 9.00 a.m. - 6.00 p.m. (except public holidays).',
              'กรณีผู้ใช้บริการเกิดปัญหาในการใช้บริการหรือต้องการติดต่อผู้ให้บริการ ผู้ใช้บริการสามารถติดต่อผู้ให้บริการผ่านทาง email : cs@shippop.com'
            )}
          </p>{' '}
        </li>

        <li>
          <span className={classes.strongStyle}> {trans('Liability', '')}</span>
          <p>
            {trans(
              'Our liability in respect of any shipment not covered by insurance is limited to direct loss and damage with a maximum of 2,000 baht per consignment note or any other amount prescribed under the terms and conditions of each Courier. The liability under this provision will not cover any delivery fee. In the event that additional insurance is purchased, the parcel will be covered under that insurance policy.',
              'สำหรับพัสดุที่ไม่ได้ซื้อความคุ้มครองไว้ ความรับผิดชอบของเราในการจัดส่งพัสดุนั้นจะจำกัดเพียงกรณีเกิดความเสียหายและสูญหายโดยตรงซึ่งมีมูลค่าชดเชยสูงสุดไม่เกิน 2,000 บาทต่อ 1 ใบนำส่งพัสดุหรือตามจำนวนเงินอื่นใดที่ผู้ให้บริการขนส่งกำหนดภายใต้เงื่อนไขของผู้ให้บริการขนส่งแต่ละราย โดยการคุ้มครองข้างต้นจะไม่ครอบคลุมในส่วนของค่าบริการจัดส่ง ในกรณีที่มีการซื้อประกันเพิ่มเติมให้การคุ้มครองพัสดุอยู่ภายใต้เงื่อนไขการประกันนั้น ๆ'
            )}
          </p>{' '}
        </li>

        <li>
          <p>
            <span className={classes.strongStyle}>
              {trans('Filing a Claim', 'การเคลมพัสดุ')}
            </span>
          </p>
          <p>
            {trans(
              'If the User wishes to make a claim after the delivered parcel has been received, the User shall submit all required documents and related evidence through cs@shippop.com or Line: @SHIPPOP within 7 days upon delivery and keeps the delivered parcel until the claim process is complete. The appropriation of the claim request and damage insurance will be considered by the Service Provider only. In the event that the claim is filed after the aforementioned period, the Service Provider reserves the right not to be responsible for any damage caused to the delivered parcel.',
              'หากผู้ใช้บริการต้องการเคลมพัสดุหลังจากที่มีการรับพัสดุแล้ว ผู้ใช้บริการจะต้องยื่นเอกสารเคลมและหลักฐานที่เกี่ยวข้องผ่านอีเมล cs@shippop.com หรือ Line : @SHIPPOP ภายใน 7 วันหลังรับพัสดุชิ้นนั้นพร้อมทั้งเก็บพัสดุไว้จนกว่ากระบวนการพิจารณาเคลมจะเสร็จสิ้น โดยผู้ให้บริการจะพิจารณาถึงความเหมาะสมในการขอเคลมสินค้าและประกันความเสียหาย ในกรณีที่มีการยื่นเคลมเกินระยะเวลาดังกล่าว ผู้ให้บริการขอสงวนสิทธิ์ไม่รับผิดชอบต่อความเสียหายใด ๆ ที่เกิดกับพัสดุ'
            )}
          </p>{' '}
        </li>

        <li>
          <p>
            <span className={classes.strongStyle}>
              {trans('Miscellaneous', 'ข้อกำหนดอื่น ๆ')}
            </span>
          </p>
          <LegalStyleDiv>
            <LegalOrderingDiv>17.1</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `If any provision of these Terms becomes or is found to be invalid, illegal, or unenforceable in any respect, the validity, legality, and enforceability of the remaining provisions shall in no way be affected or impaired thereby.`,
                  `หากข้อกำหนด ข้อตกลง สัญญา หรือข้อความใดในเงื่อนไขการใช้บริการนี้เป็นโมฆะหรือโมฆียะให้เป็นไปตามกฎหมายของไทยเท่านั้น ทั้งนี้ให้ยกเว้นส่วนที่ไม่ได้เป็นโมฆะหรือโมฆียะให้ใช้บังคับต่อไป`
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>17.2</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `These Terms are written in English and Thai language. In the event of conflict or discrepancy between English and Thai language, the Thai language shall prevail over.`,
                  `กรณีที่ข้อความใด ๆ มีความขัดหรือแย้งกัน ในฉบับภาษาไทยและฉบับแปลภาษาอื่น ๆ ให้ถือตามฉบับภาษาไทยมีผลเหนือฉบับแปลภาษาอื่น ๆ`
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>17.3</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `These Terms and all matters relating to the use of the Services are governed by and construed in accordance with the laws of Thailand. The courts of Thailand will have an exclusive jurisdiction to adjudicate any dispute arising under or in connection with these Terms.`,
                  `การกระทำใด ๆ ก็ตามที่มีผลต่อการใช้บริการของผู้ให้บริการและผู้ใช้บริการให้อยู่ภายใต้การบังคับของกฎหมายไทยเท่านั้น โดยไม่คำนึงสถานที่ตั้งของระบบ ข้อมูล และการใช้งาน รวมถึงกฎหรือบทบัญญัติว่าด้วยการเลือกกฎหมายหรือการขัดกันของกฎหมาย และให้ศาลในราชอาณาจักรไทยเป็นศาลที่มีเขตอำนาจในการพิจารณาชี้ขาดตัดสินข้อพิพาทที่เกิดขึ้นภายใต้ ข้อตกลง เงื่อนไขการใช้บริการ และนโยบายความเป็นส่วนตัว`
                )}
              </span>
            </div>
          </LegalStyleDiv>
        </li>
      </ol>
    </>
  )

  const InterContent = () => (
    <>
      <h1>{trans('Terms of Use', 'เงื่อนไขการใช้บริการ (Terms of Use)')}</h1>
      <h2>
        {trans(
          'For International Services',
          'สำหรับบริการจัดส่งพัสดุระหว่างประเทศ'
        )}
      </h2>
      <p>
        {trans(
          'Shippop Co., Ltd. is the logistic service provider that integrates domestic and international couriers into a single system. By using the Services through this website, application, or our other channels, the User will be able to use various services that make shipping convenient, fast, safe, and easy.',
          'บริษัท ชิปป๊อป จำกัด เป็นผู้ให้บริการด้านการขนส่งที่รวบรวมและเชื่อมโยงผู้ให้บริการขนส่งทั้งในและต่างประเทศมาไว้ในระบบเดียวเพื่อให้การขนส่งสะดวก รวดเร็ว ปลอดภัยและใช้ได้ทุกที่ทุกเวลา โดยผู้ใช้บริการไม่ว่าจะเป็นบุคคลทั่วไปหรือพ่อค้าแม่ค้าออนไลน์สามารถเลือกใช้บริการได้หลากหลายผ่านเว็บไซต์ แอปพลิเคชันหรือช่องทางของเราในรูปแบบต่างๆ'
        )}
      </p>
      <p>
        {trans(
          'These Terms bind the User legally and serve as a declaration of rights and obligations that the User must understand and follow. Please read through these Terms carefully for your rights and benefit. By creating an account or using the Services, you agree to and fully understand these Terms and the Privacy Policy referenced herein.',
          'เงื่อนไขการใช้บริการฉบับนี้มีผลผูกพันผู้ใช้บริการตามกฏหมายและมีวัตถุประสงค์เพื่อแจ้งให้ทราบถึงสิทธิและหน้าที่ตามกฏหมายอันพึงต้องปฏิบัติตาม โปรดอ่านเงื่อนไขการใช้บริการนี้โดยละเอียดเพื่อประโยชน์ในการรับบริการจากเรา การสมัครหรือการใช้บริการโดยผู้ใช้บริการจะถือว่าผู้ใช้บริการยอมรับว่าได้อ่านและทำความเข้าใจเงื่อนไขการใช้บริการและนโยบายความเป็นส่วนตัวโดยละเอียดถี่ถ้วนแล้ว โดยผู้ใช้บริการตกลงผูกพันและปฏิบัติตามเงื่อนไขการใช้บริการและนโยบายความเป็นส่วนตัวทุกประการ'
        )}
      </p>
      <ol>
        <li>
          <span className={classes.strongStyle}>
            {trans('Definition', 'คำจำกัดความ')}
          </span>
          <p>
            {trans(
              'Unless otherwise indicated in these Terms, the following words, when used herein, shall have the following meanings throughout these Terms:',
              'นอกเหนือจากที่ระบุไว้ในเงื่อนไขการใช้บริการนี้ ให้คำดังต่อไปนี้มีความหมายตามที่ระบุไว้ในข้อนี้ เว้นแต่มีการกำหนดเป็นอย่างอื่น'
            )}
          </p>
          <LegalStyleDiv>
            <LegalOrderingDiv>1)</LegalOrderingDiv>
            <div>
              {isEnglish ? (
                <>
                  <span className={classes.strongStyle}>
                    {/* {trans('“User”', '“ผู้ใช้บริการ” ')} */}
                    “Service Provider”
                  </span>{' '}
                  <span>or</span>{' '}
                  <span className={classes.strongStyle}>“We” </span>
                </>
              ) : (
                <span className={classes.strongStyle}>“ผู้ให้บริการ”</span>
              )}
              {/* <span>“Service Provider” or “We”</span>{' '} */}
              <span>
                {trans(
                  'means Shippop Co., Ltd., the host of the SHIPPOP websites and/or applications.',
                  'หมายถึง บริษัท ชิปป๊อป จำกัด ซึ่งเป็นผู้ให้บริการเว็บไซต์และแอปพลิเคชัน SHIPPOP หรือชื่ออื่นใดอันหมายถึงบริการดังกล่าว'
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>2)</LegalOrderingDiv>
            <div>
              <span className={classes.strongStyle}>
                {trans('“User”', '“ผู้ใช้บริการ” ')}
              </span>{' '}
              <span>
                {trans(
                  'means a person who accesses, enters, registers, or uses any of the Service Provider’s products, software, services, websites, or applications and shall mean to include the User of these Services.',
                  'หมายถึง บุคคลใดก็ตามที่เข้าถึง เข้า ลงทะเบียน หรือใช้งานผลิตภัณฑ์ ซอฟต์แวร์ บริการ เว็บไซต์ หรือแอปพลิเคชันของผู้ให้บริการไม่ว่าส่วนใดส่วนหนึ่งหรือทั้งหมดและให้หมายรวมถึงผู้ใช้บริการที่ใช้งานโดยตรงผ่านเว็บไซต์ แอปพลิชัน และ/หรือช่องทางของเราในรูปแบบต่างๆ'
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>3)</LegalOrderingDiv>
            <div>
              <span className={classes.strongStyle}>
                {trans('“User”', '“ผู้ใช้บริการ” ')}
              </span>{' '}
              <span>
                {trans(
                  'means any of our courier partners that provide their services through our websites, applications, and other channels.',
                  'หมายถึง ผู้ให้บริกาารขนส่งซึ่งเป็นพาร์ทเนอร์กับผู้ให้บริการ ซึ่งผู้ใช้บริการสามารถเลือกใช้บริการของผู้ให้บริกาารขนส่งดังกล่าวได้ผ่านช่องทางต่าง ๆ ของผู้ให้บริการ'
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>4)</LegalOrderingDiv>
            <div>
              <span className={classes.strongStyle}>
                {trans('“User”', '“ผู้ใช้บริการ” ')}
              </span>{' '}
              <span>
                {trans(
                  'means agreements, terms, clauses, contracts, or any other similar title declaring legal rights and obligations, including the Privacy Policy, which is considered as part of these Terms.',
                  'หมายถึง ข้อตกลง ข้อกำหนด ข้อสัญญา หรือชื่ออื่นใดที่มีลักษณะแบบเดียวกันเพื่อแจ้งให้ทราบถึงสิทธิและหน้าที่ตามกฎหมาย รวมถึงนโยบายความเป็นส่วนตัวซึ่งถือเป็นส่วนหนึ่งของเงื่อนไขการใช้บริการฉบับนี้'
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>5)</LegalOrderingDiv>
            <div>
              <span className={classes.strongStyle}>
                {trans('“User”', '“ผู้ใช้บริการ” ')}
              </span>{' '}
              <span>
                {trans(
                  'means the services offered through our website, application,  and other channels. The services include:',
                  'หมายถึง การให้บริการดังต่อไปนี้ผ่านเว็บไซต์ แอปพลิชัน และ/หรือผ่านช่องทางของเราในรูปแบบต่างๆ'
                )}
              </span>
              <ul style={{ listStyleType: 'disc' }}>
                <LegalLiEle>
                  {trans(
                    'Comparing shipping costs, and booking and managing delivery service; ',
                    'บริการค้นหาและเปรียบเทียบค่าขนส่งมาไว้ในระบบเดียว รวมทั้งบริการประสานงานและจัดการการขนส่ง'
                  )}
                </LegalLiEle>
                <LegalLiEle>
                  {trans('Label printing service;', 'บริการพิมพ์ใบปะหน้าพัสดุ')}
                </LegalLiEle>
                <LegalLiEle>
                  {trans(
                    'Parcel Pickup and Parcel Dropoff service;',
                    'บริการเข้ารับพัสดุหรือส่งพัสดุด้วยตนเอง'
                  )}{' '}
                </LegalLiEle>
                <LegalLiEle>
                  {trans(
                    'Track and Trace service;',
                    'บริการตรวจสอบสถานะขนส่งพัสดุ'
                  )}
                </LegalLiEle>
                <LegalLiEle>
                  {trans(
                    'Insurance service;',
                    'บริการประกันคุ้มครองการจัดส่งพัสดุ'
                  )}
                </LegalLiEle>
                <LegalLiEle>
                  {trans(
                    'any other service or feature that the Service Provider may offer to the User from time to time at its sole discretion.',
                    'บริการอื่นใดที่ผู้ให้บริการจัดให้มีขึ้นในอนาคต'
                  )}
                </LegalLiEle>
              </ul>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>6)</LegalOrderingDiv>
            <div>
              <span className={classes.strongStyle}>
                {trans('“Information” ', '“ข้อมูล” ')}
              </span>{' '}
              <span>
                {trans(
                  'means any information provided to the Service Provider via the websites, applications, and other channels.',
                  'หมายถึง ข้อมูลใด ๆ ที่ผู้ใช้บริการหรือผู้ที่ได้รับมอบอำนาจจากผู้ใช้บริการให้ทำการแทนได้ให้ไว้แก่ผู้ให้บริการผ่านทางช่องทางต่าง ๆ ไม่ว่าจะเป็นเว็บไซต์หรือแอปพลิเคชัน'
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>7)</LegalOrderingDiv>
            <div>
              <span className={classes.strongStyle}>
                {trans('“Identification Code”', '“รหัสประจำตัว”')}
              </span>{' '}
              <span>
                {trans(
                  'means Username, Password, OTP – One Time Password, whether designated by the Service Provider for the User or by the User oneself, including any other passcode or identity verification process, whatever it is called, relating to access to these Services.',
                  'หมายถึง ชื่อผู้ใช้งาน (Username) รหัสผ่าน (Password) และ รหัส OTP – One Time Password รวมถึงรหัสอื่นใด หรือวิธีการยืนยันตัวบุคคลอื่นใดที่เกี่ยวข้องกับการเข้าใช้บริการนี้ โดยไม่ว่าจะเป็นรหัสที่ผู้ใช้บริการหรือผู้ให้บริการเป็นผู้กำหนด'
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>8)</LegalOrderingDiv>
            <div>
              <span className={classes.strongStyle}>
                {trans('“Services Fees”', '“ค่าบริการ”')}
              </span>{' '}
              <span>
                {trans(
                  'means fees that the User agrees to pay for the Services provided by the Service Provider.',
                  'หมายถึง ค่าบริการที่ผู้ใช้บริการตกลงยินยอมตามที่ผู้ให้บริการเรียกเก็บ'
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>9)</LegalOrderingDiv>
            <div>
              <span className={classes.strongStyle}>
                {trans('“Agent”', '“ตัวแทน”')}
              </span>{' '}
              <span>
                {trans(
                  'means a person or an entity appointed by the Service Provider to use the system whether in whole or in part.',
                  'หมายถึง บุคคลและหรือนิติบุคคลใดก็ตาม หรือชื่ออื่นใดอันมีความหมายเดียวกัน ที่ได้รับอนุญาตและ/หรือได้รับแต่งตั้งให้สามารถนำระบบของ SHIPPOP ทั้งหมดหรือบางส่วนไปใช้'
                )}
              </span>
            </div>
          </LegalStyleDiv>
        </li>{' '}
        <li>
          <p>
            <span className={classes.strongStyle}>
              {trans('Prohibited Items', 'ขอบเขตการให้บริการ')}
            </span>
          </p>
          <p>
            {trans(
              'The Service Provider reserves the right to not provide these Services to the following items:',
              'ผู้ให้บริการขอสงวนสิทธิ์ไม่ให้บริการสำหรับพัสดุดังต่อไปนี้'
            )}
          </p>
          <LegalStyleDiv>
            <LegalOrderingDiv>1)</LegalOrderingDiv>
            <LegalBodyDiv multiply={1}>
              <span>
                {trans(
                  'Live or inanimate animals, plants, seeds, forbidden wood and herbs that are registered as drug;',
                  'สัตว์มีชีวิตหรือไม่มีชีวิต พืชพันธุ์ เมล็ดพันธุ์พืช ไม้ต้องห้ามและ สมุนไพรที่ขึ้นทะเบียนเป็นยา'
                )}
              </span>
            </LegalBodyDiv>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>2)</LegalOrderingDiv>
            <LegalBodyDiv multiply={1}>
              <span>
                {trans(
                  'Human parts or organs, relics;',
                  'อวัยวะหรือชิ้นส่วนมนุษย์ รวมถึงเถ้าอัฐิ'
                )}
              </span>
            </LegalBodyDiv>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>3)</LegalOrderingDiv>
            <LegalBodyDiv multiply={1}>
              <span>
                {trans(
                  'Fresh food, food containing liquid, food requiring temperature control;',
                  'อาหารสด อาหารที่มีน้ำประกอบ อาหารที่ต้องควบคุมอุณหภูมิ'
                )}
              </span>
            </LegalBodyDiv>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>4)</LegalOrderingDiv>
            <LegalBodyDiv multiply={1}>
              <span>
                {trans(
                  'Narcotics, items that are ilegal, contrary to public order, good morals, or defamatory or undermine the stability of religion and monarchy of the Thai nation;',
                  'สิ่งเสพติดและสิ่งอื่นใดอันผิดกฎหมาย หรือขัดต่อศีลธรรมอันดีของประชาชนชาวไทย หรือที่สร้างความเสื่อมเสีย หรือทำลายความมั่นคง ต่อประเทศชาติ ศาสนา และ สถาบันพระมหากษัตริย์'
                )}
              </span>
            </LegalBodyDiv>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>5)</LegalOrderingDiv>
            <LegalBodyDiv multiply={1}>
              <span>
                {trans(
                  'Pornography or prohibited items;',
                  'สิ่งลามกอนาจาร หรือสิ่งที่มีถ้อยคำ เครื่องหมาย ลวดลาย หยาบช้า'
                )}
              </span>
            </LegalBodyDiv>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>6)</LegalOrderingDiv>
            <LegalBodyDiv multiply={1}>
              <span>
                {trans(
                  'Flammable substances, prohibited items in air freight and any kind of batteries;',
                  'วัตถุไวไฟ สิ่งของต้องห้ามในการขนส่งทางอากาศ สินค้าที่เป็นถ่านหรือแบตเตอรี่ทุกชนิด'
                )}
              </span>
            </LegalBodyDiv>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>7)</LegalOrderingDiv>
            <LegalBodyDiv multiply={1}>
              <span>
                {trans(
                  'Sharp materials without proper packaging;',
                  'วัตถุมีคมที่ไม่มีเครื่องหุ้มห่อ ป้องกัน'
                )}
              </span>
            </LegalBodyDiv>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>8)</LegalOrderingDiv>
            <LegalBodyDiv multiply={1}>
              <span>
                {trans(
                  'Items without proper or adequate packaging, fragile items or items contained in damaged or unsuitable packaging;',
                  'วัตถุที่บรรจุหีบห่อไม่เหมาะสมต่อการขนส่ง วัตถุแตกหักง่าย รวมถึงวัตถุหีบห่อบรรจุภัณฑ์ชำรุดหรือไม่ได้มาตรฐาน'
                )}
              </span>
            </LegalBodyDiv>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>9)</LegalOrderingDiv>
            <LegalBodyDiv multiply={1}>
              <span>
                {trans(
                  'Hazardous or poisonous items, fragile items or items contained in damaged or unsuitable packaging, chemical substances, dangerous goods or items, biological hazardous items, germ, bacteria, virus, radioactive materials, products containing alcohol;',
                  'สิ่งโสโครก สิ่งมีพิษซึ่งอาจทำให้เกิดอันตราย สารเคมีทุกชนิด สินค้าอันตราย วัตถุอันตราย สิ่งที่เป็นอันตรายทางชีวภาพ เชื้อโรค เชื้อแบคทีเรีย เชื้อไวรัส สารกัมมันตภาพรังสี รวมถึงสินค้าที่มีส่วนผสมของแอลกอฮอล์'
                )}
              </span>
            </LegalBodyDiv>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>10)</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  'Prohibited items in accordance with the regulations of the International Air Transport Association, the International Air Transport Association (IATA), the International Civil Aviation Organization (ICAO), the Regulations for Dangerous Goods Transport on European Routes (ADR) and the relevant rules of any government authorities or other related organizations;',
                  'สิ่งของต้องห้ามตามข้อบังคับของสมาคมขนส่งทางอากาศระหว่างประเทศ องค์การขนส่งทางอากาศสากล (IATA) องค์การการบินพลเรือนสากล (ICAO) ข้อบังคับทางการขนส่งสินค้าอันตรายบนเส้นทางยุโรป (IDR) หรือตามกฎของหน่วยงานรัฐบาลใดๆ หรือ องค์กรอื่น ๆ ที่เกี่ยวข้อง'
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>11)</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  'Fully assembled gun, ammunition, components and all types of weapons, explosives, real and imitation firearms;',
                  'อาวุธปืนที่ประกอบเป็นชิ้นสมบูรณ์แล้ว รวมถึงกระสุน และอาวุธทุกชนิดและส่วนประกอบต่างๆของอาวุธยุทธภัณฑ์ วัตถุระเบิด – อาวุธปืนทั้งจริงและเลียนแบบ'
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>12)</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  'สิ่งของปลอมแปลงหรือลอกเลียนแบบโดยละเมิดลิขสิทธิ์',
                  'Infringement items;'
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>13)</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  'Cash and negotiable instruments equivalent to cash (such as cheque, banknotes, bond, stamp taxes), and legal documents, accounting documents , documents that have only one copy, lotteries or gambling materials;',
                  'เงินสดและสิ่งต่างๆ ที่สามารถทดแทนเงินสดได้ เช่น เช็ค ธนบัตร หรือตราสารหนี้ ภาษีอากรแสตมป์ ต่างๆ รวมถึง เอกสารนิติกรรมเฉพาะผู้ถือที่ตกลงกัน เอกสารทางบัญชี หรือเอกสารที่มีเพียงฉบับเดียว สลากกินแบ่ง หรือสื่อการพนันต่างๆ'
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>14)</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  'Precious metals or stones, bullions, jewelry, gems and other high-value items such as amulet, religious statues, and  antique;',
                  'โลหะหรือหินอันมีค่า ทองคำ เครื่องเพชร พลอย อัญมณี หรือสิ่งของที่มีมูลค่าสูงต่างๆ รวมถึงองค์พระ พระเครื่อง เทวรูป และวัตถุโบราณต่างๆ'
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>15)</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  'Undeclared items subject to applicable customs regulations; and',
                  'วัตถุที่ไม่ได้ทำการสำแดงรายละเอียดต่อศุลกากรเมื่อเข้าเกณฑ์ที่จะต้องกระทำตามกฎระเบียบของกรมศุลกากรที่บังคับใช้'
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>16)</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `Prohibited or unacceptable items under the Courier's shipment policies and items that are heavier than the weight specified by the Courier.`,
                  `สิ่งอื่นใดที่เป็นพัสดุต้องห้ามหรือเป็นพัสดุที่ไม่รับขนส่งตามนโยบายของผู้ให้บริการขนส่ง หรือพัสดุที่มีขนาดหรือน้ำหนักเกินกว่าที่ผู้ให้บริการขนส่งกำหนด`
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>17)</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  'The Service Provider may, without prior notice, amend the list of prohibited items through this website,  application, or any other method, as it thinks fit, from time to time. The User is obligated to check that his/her delivered materials are not the prohibited item set out above. If it is found that the shipment contained the prohibited items, the Service Provider shall not be liable for any damages and the User will be solely responsible for all damages.',
                  'กรณีที่มีการเปลี่ยนแปลงรายการพัสดุข้างต้นนั้น ผู้ให้บริการจะแจ้งให้ทราบเพิ่มเติมทางเว็บไซต์หรือช่องทางอื่นโดยมิต้องแจ้งให้ทราบล่วงหน้า และผู้ใช้บริการมีหน้าที่ตรวจสอบว่าพัสดุใด ๆ เป็นสิ่งของที่ผู้ให้บริการขอสงวนสิทธิ์ไม่ให้บริการ ในกรณีที่มีการใช้บริการสำหรับพัสดุข้างต้น ผู้ให้บริการจะไม่รับผิดชอบใด ๆ ทั้งสิ้นและผู้ใช้บริการตกลงเป็นผู้รับผิดชอบในความเสียหายที่เกิดขึ้นทั้งหมดแต่เพียงผู้เดียว'
                )}
              </span>
            </div>
          </LegalStyleDiv>
        </li>{' '}
        <li>
          <p>
            <span className={classes.strongStyle}>
              {trans('Eligibility', 'คุณสมบัติผู้ใช้บริการ')}
            </span>
          </p>
          <p>
            {trans(
              'To be eligible to use the Services, the User must be capable of entering into and performing legally binding contracts under Thai laws. If the User is non-sui juris and incapable of performing legally binding contracts under Thai laws, the parent or guardian of the User must create an account and agree to these Terms on behalf of the User who is under your supervision. The Services are not available to the User if all the aforementioned conditions are not met.',
              'ผู้ใช้บริการจะต้องมีความสามารถในการเข้าทำนิติกรรมและสามารถปฏิบัติตามเงื่อนไขการใช้บริการนี้ภายใต้กฎหมายไทย ในกรณีที่ผู้ใช้บริการยังไม่บรรลุนิติภาวะและไม่มีความสามารถในการเข้าทำนิติกรรม บิดามารดาหรือผู้ปกครองของผู้ใช้บริการจะต้องให้ความยินยอม รวมทั้งยอมรับตามเงื่อนไขการใช้บริการนี้ก่อนรับบริการ และสมัครสมาชิกและใช้บริการในนามของผู้เยาว์ซึ่งอยู่ในความปกครองโดยท่านรับรองว่าท่านเป็นบิดามารดาหรือผู้ปกครองโดยชอบด้วยกฎหมายของผู้เยาว์จริงและผู้เยาว์ดังกล่าวอยู่ในความปกครองของท่าน ในกรณีที่ผู้ใช้บริการไม่มีคุณสมบัติข้างต้นผู้ให้บริการขอสงวนสิทธิ์ที่จะไม่ให้บริการ'
            )}
          </p>
        </li>{' '}
        <li>
          <span className={classes.strongStyle}>
            {trans('Creating Account', 'การสมัครสมาชิกของผู้ใช้บริการ')}
          </span>
          <LegalStyleDiv>
            <LegalOrderingDiv>4.1</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  'To completely use the Services, the User may register an account on this website or application.',
                  'เพื่อให้ผู้ใช้บริการสามารถใช้บริการได้อย่างครบถ้วนและมีประสิทธิภาพ ผู้ใช้บริการสามารถสมัครเข้าเป็นสมาชิกของผู้ให้บริการได้ผ่านทางเว็บไซต์หรือแอปพลิเคชันนี้'
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>4.2</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  'The User may create an account by registering his/her Facebook ID or email. In order to create an account by using your email, the User must provide the Service Provider with certain information, including name, surname, phone number, email, and password, as well as verify identity via e-mail.',
                  'ผู้ใช้บริการอาจสมัครสมาชิกผ่าน Facebook โดยยืนยันการขอใช้งาน หรือสมัครสมาชิกผ่านอีเมล ซึ่งผู้ใช้บริการจะต้องกรอกข้อมูลต่าง ๆ ซึ่งได้แก่ ชื่อ-นามสกุล เบอร์โทรศัพท์ติดต่อ อีเมล และรหัสผ่าน รวมทั้งยืนยันตัวตนผ่านทางอีเมล โดยเมื่อการลงสมัครสมาชิกเรียบร้อยแล้ว ระบบจะทำการสร้างบัญชีผู้ใช้เพื่อให้ท่านสามารถเข้าใช้บริการได้อย่างครบถ้วน'
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>4.3</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `For providing accurate Services to the User, the User represents and warrants that all information provided by the User is true, accurate, complete, up-to-date, and not misleading. If the information changes, the User may update the information in the settings menu by selecting “Edit personal information”.`,
                  'ผู้ใช้บริการตกลงรับรองว่าข้อมูลต่าง ๆ ที่ผู้ใช้บริการแจ้งในการสมัครสมาชิกนั้นเป็นข้อมูลที่ถูกต้อง ครบถ้วน เป็นปัจจุบัน และไม่ก่อให้เกิดความเข้าใจผิด ในกรณีที่ข้อมูลมีการเปลี่ยนแปลง ผู้ใช้บริการสามารถแก้ไขข้อมูลได้ที่เมนูการตั้งค่าและเลือก “แก้ไขข้อมูลส่วนตัว” เพื่อให้ผู้ให้บริการให้บริการได้อย่างถูกต้อง'
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>4.4</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `Upon successful registration, the User must not share or transfer the Identification Code and the account with anyone. The User must be responsible for all activities that occur under your account. If a third party uses the account and causes damage or loss to anyone, the Service Provider will not be responsible for such damage or loss in any way.`,
                  `เมื่อสร้างบัญชีผู้ใช้เรียบร้อยแล้ว ผู้ใช้บริการจะต้องไม่เปิดเผยรหัสประจำตัวหรืออนุญาตให้ผู้อื่นใช้บัญชีผู้ใช้ของผู้ใช้บริการ หากผู้ใช้บริการเปิดเผยรหัสส่วนตัวหรืออนุญาตให้บุคคลอื่นใช้บัญชีผู้ใช้ของตน ผู้ให้บริการจะถือว่าการปฏิบัติของบุคคลภายนอกดังกล่าวคือการปฏิบัติของผู้ใช้บริการ และหากการปฏิบัติของบุคคลดังกล่าวก่อให้เกิดความเสียหายหรือการเสียผลประโยชน์แก่บุคคลใด ๆ ผู้ให้บริการจะไม่รับผิดชอบทั้งสิ้น`
                )}
              </span>
            </div>
          </LegalStyleDiv>
        </li>{' '}
        <li>
          <p>
            <span className={classes.strongStyle}>
              {trans('Using the Services', 'การใช้บริการ')}
            </span>
          </p>
          <LegalStyleDiv>
            <LegalOrderingDiv>5.1</LegalOrderingDiv>
            <LegalBodyDiv multiply={1}>
              <span>
                {trans(
                  `The User must understand and agree with these Terms, the Privacy Policy, and the service policy of the Courier before registering an account or using the Services.`,
                  `การใช้บริการของผู้ให้บริการนั้น ผู้ใช้บริการต้องเข้าใจและยอมรับข้อตกลง เงื่อนไขการใช้บริการ และนโยบายความเป็นส่วนตัวต่าง ๆ ของผู้ให้บริการทั้งหมด รวมถึงนโยบายการให้บริการของผู้ให้บริการขนส่งที่ผู้ใช้บริการเลือกก่อน`
                )}
              </span>
            </LegalBodyDiv>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>5.2</LegalOrderingDiv>
            <LegalBodyDiv multiply={1}>
              <span>
                {trans(
                  `The User must provide accurate, complete, current, and true information in all respects to the Service Provider, as well as verify his/her identity according to the procedures prescribed by the Service Provider. Any provided information is assumed to be correct, complete, and lawful. The Service Provider may, in some circumstances, require additional documents to verify any provided Information at any time, and the User agrees to comply with such request. If any provided Information is inaccurate, the User accepts to pay the Service Provider the actual Service Fees or expenses. The Service Provider shall have no responsibility for any mistake arising from any inaccurate information.`,
                  `ผู้ใช้บริการต้องให้ข้อมูลที่ถูกต้อง ครบถ้วน เป็นปัจจุบันและเป็นจริงทุกประการแก่ผู้ให้บริการ รวมทั้งยืนยันตัวตนตามวิธีการที่ให้บริการกำหนด เพื่อประโยชน์ในการให้บริการ การกรอกข้อมูลใด ๆ โดยผู้ใช้บริการจะถือว่าผู้ใช้บริการได้ให้คำรับรองว่าข้อมูลดังกล่าวถูกต้อง ครบถ้วน และชอบด้วยกฎหมาย ในบางกรณีผู้ให้บริการอาจร้องขอเอกสารเพิ่มเติมเพื่อยืนยันข้อมูลต่าง ๆ และผู้ใช้บริการยอมรับที่ต้องปฏิบัติตามคำร้องขอ ทั้งนี้ หากตรวจสอบแล้วพบว่ามีการให้ข้อมูลไม่ถูกต้อง ผู้ใช้บริการยินยอมให้ผู้ให้บริการเรียกเก็บเงินส่วนต่างจากผู้ใช้บริการในภายหลังได้ตามจริงและผู้ให้บริการจะไม่รับผิดในความเสียหายใด ๆ ที่เกิดจากข้อมูลที่ไม่ถูกต้อง`
                )}
              </span>
            </LegalBodyDiv>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>5.3</LegalOrderingDiv>
            <LegalBodyDiv multiply={1}>
              <span>
                {trans(
                  `The Couriers selected by the User cannot be modified. Subject to the Courier’s policy, the User may modify the provided Information by contacting our customer service.`,
                  `ในกรณีที่ข้อมูลเกี่ยวกับบริการขนส่งเปลี่ยนแปลงไป ผู้ใช้บริการจะไม่สามารถแก้ไขหรือเปลี่ยนแปลงผู้ให้บริการขนส่งที่เลือกได้ เว้นแต่เป็นไปตามเงื่อนไขของผู้ให้บริการขนส่งที่เลือก โดยการแก้ไขข้อมูลดังกล่าวจะต้องติดต่อผ่านฝ่ายบริการลูกค้าของผู้ให้บริการเท่านั้น`
                )}
              </span>
            </LegalBodyDiv>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>5.4</LegalOrderingDiv>
            <LegalBodyDiv multiply={1}>
              <span>
                {trans(
                  `The User must not import or export any data and/or document from our websites or applications in a manner that is likely to cause damage to devices, hardware, or software, whether it is illegal or not.`,
                  `ผู้ให้บริการไม่อนุญาตให้นำเข้าและ/หรือส่งออกซึ่งข้อมูลใด ๆ และ หรือเอกสารใด ๆเข้ามาในเว็บไซต์หรือแอปพลิเคชันโดยประการที่อาจทำให้เกิดความเสียหายแก่อุปกรณ์ ฮาร์ดแวร์ หรือซอฟท์แวร์ไม่ว่าจะเป็นความผิดตามกฎหมายหรือไม่`
                )}
              </span>
            </LegalBodyDiv>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>5.5</LegalOrderingDiv>
            <LegalBodyDiv multiply={1}>
              <span>
                {trans(
                  `The User must not attempt or act to disrupt or interfere with our computer and network systems and conduct any illegal activity.`,
                  `ผู้ใช้บริการต้องไม่พยายามหรือกระทำการใดๆที่เป็นอันตรายต่อความปลอดภัยของระบบคอมพิวเตอร์หรือระบบเน็ตเวิร์ค ซึ่งหมายรวมถึงการกระทำผิดใดๆตามที่กฎหมายกำหนด`
                )}
              </span>
            </LegalBodyDiv>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>5.6</LegalOrderingDiv>
            <LegalBodyDiv multiply={1}>
              <span>
                {trans(
                  `The User is not permitted to transfer any of his/her rights or obligations under these Terms to anyone else.`,
                  `ผู้ให้บริการไม่อนุญาตให้ผู้ใช้บริการโอนสิทธิและหน้าที่ภายใต้ข้อตกลง เงื่อนไขการใช้บริการ และนโยบายความเป็นส่วนตัวแก่บุคคลและหรือนิติบุคคลอื่นโดยเด็ดขาด`
                )}
              </span>
            </LegalBodyDiv>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>5.7</LegalOrderingDiv>
            <LegalBodyDiv multiply={1}>
              <span>
                {trans(
                  `In order to use some of the Services, the Users may be required to enter into additional contracts or agreements.`,
                  `ในการใช้บริการบางประเภท ผู้ใช้บริการอาจต้องตกลงทำสัญญาหรือข้อตกลงอื่นใดเพิ่มเติมเพื่อใช้บริการนั้น ๆ`
                )}
              </span>
            </LegalBodyDiv>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>5.8</LegalOrderingDiv>
            <LegalBodyDiv multiply={1}>
              <span>
                {trans(
                  `The User agrees to be responsible for all activities that are done in accordance with these Terms in all respects or are done by us or our representative upon the User’s request.`,
                  `บรรดาการใด ๆ ที่ผู้ให้บริการได้กระทำไปตามเงื่อนไขการใช้บริการ และ/หรือ ตามข้อมูลหรือตามคำร้องขอที่ผู้ใช้บริการซึ่งได้แจ้งต่อผู้ให้บริการหรือตัวแทนให้มีผลผูกพันผู้ใช้บริการทุกประการ`
                )}
              </span>
            </LegalBodyDiv>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>5.9</LegalOrderingDiv>
            <LegalBodyDiv multiply={1}>
              <span>
                {trans(
                  `The User must not use the Services in any manner that violate these Terms, laws, and regulations of origin and destination countries, public morals, or in any abnormal manners that will likely cause damages to any person. All international, federal, state, and local laws must be complied with by the User.`,
                  `ผู้ใช้บริการจะไม่ใช้บริการนี้เพื่อวัตถุประสงค์ที่ขัดต่อเงื่อนไขการใช้บริการ กฎหมาย ศีลธรรมหรือกฎหมายของประเทศต้นกำเนิดหรือประเทศปลายทางหรือข้อบังคับอื่น ๆ หรือก่อให้เกิดความเสียหายแก่บุคคลใด ๆและจะต้องปฏิบัติตามกฎหมายหรือกฎระเบียบต่าง ๆ ซึ่งรวมถึงกฏหมายระหว่างประเทศสหพันธ์รัฐและท้องถิ่นทั้งหมด`
                )}
              </span>
            </LegalBodyDiv>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>5.10</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `The User must not use the Services in any manner that violate these Terms, laws, and regulations of origin and destination countries, public morals, or in any abnormal manners that will likely cause damages to any person. All international, federal, state, and local laws must be complied with by the User.`,
                  `ผู้ใช้บริการจะไม่ใช้บริการนี้เพื่อวัตถุประสงค์ที่ขัดต่อเงื่อนไขการใช้บริการ กฎหมาย ศีลธรรมหรือกฎหมายของประเทศต้นกำเนิดหรือประเทศปลายทางหรือข้อบังคับอื่น ๆ หรือก่อให้เกิดความเสียหายแก่บุคคลใด ๆและจะต้องปฏิบัติตามกฎหมายหรือกฎระเบียบต่าง ๆ ซึ่งรวมถึงกฏหมายระหว่างประเทศสหพันธ์รัฐและท้องถิ่นทั้งหมด`
                )}
              </span>
            </div>
          </LegalStyleDiv>

          <LegalStyleDiv>
            <LegalOrderingDiv>5.11</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `By using the Services, the User warrants that he/she owns or possesses the lawful right of any delivered items`,
                  `ผู้ใช้บริการรับรองว่าตนเป็นเจ้าของหรือมีสิทธิในสิ่งของที่ใช้บริการนี้โดยชอบด้วยกฎหมาย`
                )}
              </span>
            </div>
          </LegalStyleDiv>

          <LegalStyleDiv>
            <LegalOrderingDiv>5.12</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `The duration of the User’s shipment shown on this website or application is an estimated time and may be changed or postponed due to the Courier, force majeure, or unfavorable weather conditions. Therefore, the Service Provider cannot guarantee the shown duration of the Service and the shown duration of the Services must not blind the Service Provider. The Service Provider will not reliable for any loss or damage arising from delayed shipment. `,
                  `ระยะเวลาการบริการที่แสดงเป็นระยะเวลาที่ถูกประมาณการและอาจมีการเปลี่ยนแปลงหรือล่าช้ากว่าที่กำหนด เนื่องจากผู้ให้บริการขนส่ง เหตุสุดวิสัย หรือสภาพอากาศที่ไม่เอื้ออำนวยต่อการให้บริการ โดยผู้ให้บริการไม่อาจรับประกันระยะเวลาการบริการดังกล่าวได้และระยะเวลานั้นไม่ถือเป็นข้อผูกพันผู้ให้บริการ โดยผู้ให้บริการ`
                )}
              </span>
            </div>
          </LegalStyleDiv>

          <LegalStyleDiv>
            <LegalOrderingDiv>5.13</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `The User agrees to fully compensate the Service Provider, the Courier, or any other person for any loss and damage incurred from breach of these Terms.`,
                  `ผู้ใช้บริการยินยอมรับผิดเต็มจำนวนสำหรับความสูญเสีย และความเสียหายที่เกิดขึ้นกับผู้ให้บริการ ผู้ให้บริการขนส่งหรือบุคคลอื่นใดจากการฝ่าฝืนเงื่อนไขการใช้บริการนี้`
                )}
              </span>
            </div>
          </LegalStyleDiv>

          <LegalStyleDiv>
            <LegalOrderingDiv>5.14</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `We and the Courier reserve the right to open and inspect any delivered packaging without prior notice to the User for safety, security, customs, or regulatory reasons.`,
                  `ผู้ให้บริการหรือผู้ให้บริการขนส่งมีสิทธิในการเปิดตรวจสอบสิ่งจัดส่งโดยไม่ต้องแจ้งให้ผู้ใช้บริการทราบ ด้วยเหตุผลเรื่องความปลอดภัย การปฏิบัติกฎหมาย กระบวนการศุลกากรหรือเหตุผลที่ชอบอื่น`
                )}
              </span>
            </div>
          </LegalStyleDiv>

          <LegalStyleDiv>
            <LegalOrderingDiv>5.15</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `The User authorizes the Service Provider to act on the User’s behalf to complete custom clearance processes. However, the Service Provider will not sign or execute any documents on the Customer’s behalf.`,
                  `ผู้ใช้บริการอนุญาตให้ผู้ให้บริการดำเนินการในนามของผู้ใช้บริการในเอกสารใด ๆ ที่จำเป็นตามกฎหมายเพื่อการส่งออกหรือนำเข้าพิธีการ อย่างไรก็ตาม ผู้ให้บริการไม่ได้ดำเนินการใด ๆ โดยอาศัยอำนาจตามที่ได้รับอนุญาตดังกล่าวเพื่อลงนามหรือดำเนินการเอกสารใด ๆ ในนามของผู้ใช้บริการ`
                )}
              </span>
            </div>
          </LegalStyleDiv>

          <LegalStyleDiv>
            <LegalOrderingDiv>5.16</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `The User accepts all delivery routes and route alterations. The delivered parcels may be delivered via routes that are halted or rested in between.`,
                  `ผู้ใช้บริการต้องยอมรับเส้นทางและการเปลี่ยนแปลงเส้นทางทุกเส้นทาง รวมถึงความเป็นไปได้ในการที่พัสดุจะถูกส่งโดยเส้นทางที่ต้องมีการหยุดหรือพักระหว่างเส้นทาง`
                )}
              </span>
            </div>
          </LegalStyleDiv>

          <LegalStyleDiv>
            <LegalOrderingDiv>5.17</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `If any parcel cannot be shipped by any reasons, the User as the sender must receive such returned parcel within 14 days from the date that the Service Provider acknowledges the delivery order. If the prescribed period is exceeded, the Service Provider will not be responsible for any loss or damage that may occur.`,
                  `พัสดุที่ไม่สามารถดำเนินการจัดส่งได้ ไม่ว่าด้วยเหตุอันใด ผู้ใช้บริการต้องรับคืนพัสดุนั้นภายใน 14 วัน นับจากวันที่ผู้ให้บริการตอบรับการจัดส่ง หากเลยเวลากำหนดผู้ให้บริการจะไม่รับผิดชอบต่อความสูญหายหรือเสียหายใด ๆ ที่อาจเกิดขึ้น`
                )}
              </span>
            </div>
          </LegalStyleDiv>

          <LegalStyleDiv>
            <LegalOrderingDiv>5.18</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `The Service Provider will use reasonable efforts to delivery the parcel on time. However, the shown delivery schedule is not considered  as a commitment and is not part of these Terms or any agreements. The Service Provider will not be responsible for any losses or damages incurred as a result of the delay.`,
                  `ผู้ให้บริการจะทำการพยายามอย่างเหมาะสมในการดำเนินการจัดส่งให้ตรงตามหมายกำหนดการปกติ โดยตารางเวลานี้จะไม่ถือเป็นข้อผูกพันและไม่ใช่ส่วนหนึ่งของเงื่อนไขการใช้บริการหรือข้อตกลงใด ๆ โดยผู้ให้บริการจะไม่รับผิดชอบต่อการสูญหาย หรือความเสียหายใด ๆ ทั้งสิ้นที่เกิดจากความล่าช้า`
                )}
              </span>
            </div>
          </LegalStyleDiv>

          <LegalStyleDiv>
            <LegalOrderingDiv>5.19</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `If the Customer does not exercise the right to receive the shipment, the Service Provider may, at its sole discretion, discard, destroy, auction, or otherwise dispose of any of the delivered parcels within 21 days after the receipt to the delivered parcels.`,
                  `หากผู้ใช้บริการไม่แสดงสิทธิเข้ารับพัสดุจากการขนส่งดังกล่าวต่อผู้ให้บริการ ผู้ให้บริการอาจใช้ดุลยพินิจแต่เพียงผู้เดียวในการกำจัด ทำลาย ประมูล หรือจำหน่ายพัสดุใด ๆ ของผู้ใช้บริการภายใน 21 วันนับหลังจากวันที่เข้ารับสินค้า `
                )}
              </span>
            </div>
          </LegalStyleDiv>

          <LegalStyleDiv>
            <LegalOrderingDiv>5.20</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `The User shall not use the “Drop and Ship” address for any other purpose including, but without limitation, using the address and other details as a billing address or the User’s physical address. If the User violates this provision, the Service Provider may immediatel ycease any Services provided to the User.`,
                  `ผู้ใช้บริการรับรองว่าจะไม่ใช้ที่อยู่ “Drop and Ship” เพื่อวัตถุประสงค์อื่นใดนอกเหนือจากการใช้บริการตามปกติ รวมถึงแต่ไม่จำกัดเพียงการใช้ที่อยู่และรายละเอียดของบัญชีเป็นที่อยู่สำหรับการเรียกเก็บเงิน หรือใช้เป็นที่อยู่ในการติดต่อของผู้ใช้บริการ หากผู้ใช้บริการฝ่าฝืนความในข้อนี้ ผู้ให้บริการจะยกเลิกบริการใด ๆ ของผู้ใช้บริการทันที`
                )}
              </span>
            </div>
          </LegalStyleDiv>
        </li>{' '}
        <li>
          <p>
            <span className={classes.strongStyle}>
              {trans('Service Fees and Payment', 'ค่าบริการและการชำระเงิน')}
            </span>
          </p>

          <LegalStyleDiv>
            <LegalOrderingDiv>6.1</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `The Service Fees shown on this website or application are initial fees that are calculated based on the distance, size, and weight information provided by the User. If the Service Provider acknowledges that such provided information is incorrectly, the actual fee will be charged to the User. The Service Provider reserves the right to change the rates of the Service Fees, shipping rates and any other related charges herein without notifying the User in advance, at its sole discretion.`,
                  `ค่าบริการที่แสดงบนเว็บไซต์หรือแอปพลิเคชันนี้เป็นค่าบริการเบื้องต้นซึ่งคำนวณตามระยะทาง ขนาด และน้ำหนักที่ผู้ใช้บริการเป็นผู้กรอกข้อมูล หากตรวจสอบแล้วพบว่ามีการระบุระยะทาง ขนาดหรือน้ำหนักไม่ถูกต้อง ผู้ให้บริการสามารถเรียกเก็บเงินส่วนต่างภายหลังได้ตามจริง ทั้งนี้ ผู้ให้บริการขอสงวนสิทธิ์ในการเปลี่ยนแปลงค่าจัดส่ง ค่าบริการและค่าใช้จ่ายอื่น ๆ ที่ปรากฏแก่ผู้ใช้บริการในเวลาใด ๆ โดยมิต้องแจ้งให้ผู้ใช้บริการทราบล่วงหน้า`
                )}
              </span>
            </div>
          </LegalStyleDiv>

          <LegalStyleDiv>
            <LegalOrderingDiv>6.2</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `Fuel surcharge rates of the "Door to Door" service may be vary depending on the User's location. The Service Provider will calculate the “Door to Door” rates based on gross weight or volumetric weight (L x W x H / 5000), whichever higher.`,
                  `อัตราการจัดส่งแบบ “Door to Door” อาจมีการคิดค่าธรรมเนียมเชื้อเพลิงผันแปรตามพื้นที่ของผู้ใช้บริการ และผู้ให้บริการจะคำนวณอัตราการจัดส่ง “Door to Door” ตามมูลค่าการขนส่งที่สูงกว่าระหว่างน้ำหนักรวม(Gross weight) หรือปริมาตรน้ำหนัก(Volumetric weight) (L x W x H / 5000)`
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>6.3</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `Fuel surcharge rates of the "Door to Door" service may be vary depending on the User's location. The Service Provider will calculate the “Door to Door” rates based on gross weight or volumetric weight (L x W x H / 5000), whichever higher.`,
                  `ผู้ใช้บริการตกลงรับผิดชอบในค่าบริการหรือค่าใช้จ่ายต่าง ๆ ที่เกิดขึ้นจากการให้บริการนี้ที่มีการเรียกเก็บค่าใช้จ่าย แม้ต่อมาจะปรากฏว่ามีความผิดพลาดที่เกิดขึ้นจากการป้อนข้อมูลหรือส่งข้อมูลจากผู้ใช้บริการ สำหรับเงื่อนไขการชำระเงินค่าบริการและอัตราค่าบริการให้เป็นไปตามนโยบายที่ผู้ให้บริการกำหนดในขณะนั้น`
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>6.4</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `The User allows the Service Provider to use and disclose his/her personal data for the purpose of payment.`,
                  `ภายใต้นโยบายความเป็นส่วนตัวของผู้ให้บริการ ผู้ใช้บริการตกลงให้ผู้ให้บริการดำเนินการเรียกเก็บเงินและเปิดเผยข้อมูลส่วนบุคคลให้กับสถาบันการเงินหรือผู้ให้บริการที่ดำเนินการชำระเงินซึ่งเป็นบุคคลที่สาม เพื่อยืนยันการตัวตนและชำระเงิน`
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>6.5</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `Unless otherwise prescribed in These Terms, the User acknowledges and accepts that the Service Provider will not refund the Service Fee and other expenses if the parcel has been processed into the system or the Services have been delivered.`,
                  `ผู้ใช้บริการรับทราบและตกลงว่าผู้ให้บริการจะไม่คืนเงินค่าบริการและค่าใช้จ่ายต่าง ๆ ทุกกรณีเมื่อมีการนำพัสดุเข้าสู่ระบบของผู้ให้บริการหรือมีการให้บริการเรียบร้อยแล้ว เว้นแต่เป็นกรณีที่กำหนดไว้ในเงื่อนไขการใช้บริการฉบับนี้`
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>6.6</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `Payments made by bank transfer or online method will be deemed to be completed, if the Service Provider has received proof of payment.`,
                  `ในการชำระเงินผ่านการโอนเงินผ่านบัญชีธนาคารหรือการชำระเงินผ่านระบบออนไลน์ จะถือว่าการชำระเงินนั้นเสร็จสมบูรณ์ เมื่อผู้ให้บริการได้รับหลักฐานการชำระเงินและทำการตรวจสอบได้เรียบร้อยแล้ว`
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>6.7</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `The Service Provider reserves the right to restore the Services. In the event that the User cancels the Services or cuts down the Service before the end of the contract. The user has no right to refund the Service Fee in any circumstance, unless the Service Provider found it reasonable to refund the Service Fee. If there is a violation in the agreement, the Service Provider shall have the right to notify the User and terminate the contract. If there isn’t any improvement and the action affects the system, network, or reputation of the Service Provider, the User shall be solely responsible for all damages that occur.`,
                  `ผู้ให้บริการขอสงวนสิทธิ์ในการคืนค่าใด ๆ ในกรณีที่ผู้ใช้ต้องการยกเลิกใช้บริการหรือปรับลดบริการลงก่อนครบกำหนดสัญญา (ถ้ามี) และผู้ใช้บริการไม่มีสิทธิ์เรียกค่าบริการใด ๆ คืนไม่ว่าบางส่วนหรือทั้งหมดได้ เว้นแต่ทางผู้ให้บริการจะเป็นผู้ยกเลิกบริการเอง โดยในกรณีนี้ผู้ให้บริการจะคืนค่าบริการตามสมควรให้เท่านั้น หากมีการละเมิดข้อตกลงดังกล่าวผู้ให้บริการจะแจ้งเตือน และจะหยุดให้บริการ หากผู้ใช้บริการไม่ทำการแก้ไขให้ถูกต้อง และผู้ใช้บริการจะไม่สามารถเรียกร้องสิทธิ์ในการคืนเงินได้ และหากเป็นการกระทำที่ส่งผลกระทบต่อ ระบบ เครือข่าย และชื่อเสียงของผู้ให้บริการ ผู้ใช้บริการจะต้องรับผิดชอบความเสียหายที่เกิดขึ้นทั้งหมด `
                )}
              </span>
            </div>
          </LegalStyleDiv>
        </li>{' '}
        <li>
          <p>
            <span className={classes.strongStyle}>
              {trans('Taxes and Fees', 'ภาษีอากรและค่าธรรมเนียม')}
            </span>
          </p>

          <LegalStyleDiv>
            <LegalOrderingDiv>7.1</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `The Service Fees do not include all local airport taxes, VAT, customs duties, levies, fees, imposts, deposits, or outlays incurred in respect of the shipment, which shall be the sole responsibility of the User. The User must pay VAT of any customs duties, fees and/or applicable taxes amount.`,
                  `อัตราค่าบริการจะไม่รวมภาษีสนามบินท้องถิ่นทั้งหมด ภาษีมูลค่าเพิ่ม ภาษีศุลกากร การเรียกเก็บค่าธรรมเนียม ศุลกากร เงินฝาก หรือค่าใช้จ่ายที่เกิดขึ้นจากการขนส่งพัสดุของผู้ใช้บริการซึ่งจะเป็นความรับผิดชอบของผู้ใช้บริการ เว้นแต่จะระบุไว้เป็นอย่างอื่นโดยผู้ใช้บริการต้องชำระภาษีมูลค่าเพิ่มในส่วนของค่าใช้จ่ายข้างต้น`
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>7.2</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `The Service Provider shall not be obligated to pay any customs duties, fees and/or applicable taxes on behalf of the User. The User shall pay customs duties, fees and applicable taxes on imported shipments before the releasing of the shipment and/or the shipping documents.`,
                  `ผู้ให้บริการจะไม่มีภาระผูกพันในการชำระภาษีศุลกากร ค่าธรรมเนียมและ /หรือภาษีที่เกี่ยวข้องในนามของผู้ใช้บริการ ผู้ใช้บริการจะต้องจ่ายภาษีศุลกากรค่าธรรมเนียมและภาษีที่เกี่ยวข้องกับการจัดส่งที่นำเข้าก่อนผู้ให้บริการที่ปล่อยการจัดส่งและ / หรือเอกสารการจัดส่ง`
                )}
              </span>
            </div>
          </LegalStyleDiv>
        </li>{' '}
        <li>
          <p>
            {' '}
            <span className={classes.strongStyle}>
              {trans('Personal Data Protection', 'การคุ้มครองข้อมูลส่วนบุคคล')}
            </span>
          </p>

          <LegalStyleDiv>
            <LegalOrderingDiv>8.1</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `Before using the Services, please carefully read the detail of our Privacy Policy at https://www.shippop.com/en/privacy.`,
                  `ก่อนตัดสินใจใช้บริการนี้ ผู้ใช้บริการต้องศึกษานโยบายความเป็นส่วนตัวตามที่ปรากฏใน  https://www.shippop.com/privacy `
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>8.2</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `The User’s personal data will be kept confidential, except as follows;`,
                  `ข้อมูลส่วนบุคคลของผู้ใช้บริการจะไม่ถูกเปิดเผยให้แก่บุคคลภายนอก เว้นแต่`
                )}
                <ul style={{ listStyleType: 'disc' }}>
                  <LegalLiEle>
                    {trans(
                      'in case we obtained the consent from the User;',
                      'ได้รับความยินยอมจากผู้ใช้บริการ'
                    )}
                  </LegalLiEle>
                  <LegalLiEle>
                    {trans(
                      'in case we are required by laws or court order; or ',
                      'กระทำการตามที่กฎหมายบังคับและ/หรือตามคำสั่งหรือหมายของศาล '
                    )}
                  </LegalLiEle>
                  <LegalLiEle>
                    {trans(
                      'in case of processing of personal subject to our Privacy Policy.',
                      'เป็นไปตามนโยบายความเป็นส่วนตัว'
                    )}
                  </LegalLiEle>
                </ul>
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>8.3</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `Under laws, these Terms, and the Privacy Policy, the Service Provider may, without prior notice, use any information provided by the User, including personal data, for research, analysis, differentiation, or any other purpose as the Service Provider deems appropriate.`,
                  `ภายใต้กฎหมาย เงื่อนไขการใช้บริการ และนโยบายความเป็นส่วนตัว ผู้ให้บริการสามารถนำข้อมูลใด ๆ ก็ตามที่ผู้ใช้บริการให้กับผู้ให้บริการผ่านช่องทางต่าง ๆ ไปใช้ในการวิจัย วิเคราะห์ แยกแยะ หรือวัตถุประสงค์อื่นใดตามที่เห็นสมควร โดยมิต้องแจ้งให้ทราบล่วงหน้าไม่ว่าข้อมูลดังกล่าวจะเป็นข้อมูลส่วนบุคคลหรือไม่`
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>8.4</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `Under laws, these Terms, and the Privacy Policy, the Service Provider may, without prior notice, use any information provided by the User, including personal data, for research, analysis, differentiation, or any other purpose as the Service Provider deems appropriate.`,
                  `ภายใต้กฎหมาย เงื่อนไขการใช้บริการ และนโยบายความเป็นส่วนตัว ผู้ให้บริการสามารถนำข้อมูลใด ๆ ก็ตามที่ผู้ใช้บริการให้กับผู้ให้บริการผ่านช่องทางต่าง ๆ ไปใช้ในการวิจัย วิเคราะห์ แยกแยะ หรือวัตถุประสงค์อื่นใดตามที่เห็นสมควร โดยมิต้องแจ้งให้ทราบล่วงหน้าไม่ว่าข้อมูลดังกล่าวจะเป็นข้อมูลส่วนบุคคลหรือไม่`
                )}
              </span>
            </div>
          </LegalStyleDiv>
        </li>{' '}
        <li>
          <span className={classes.strongStyle}>
            {trans(
              'Intellectual Property and Trademark',
              'ทรัพย์สินทางปัญญาและเครื่องหมายการค้า'
            )}
          </span>
          <p>
            {trans(
              'The Service Provider owns all rights, titles, and interests in any and all contents, trademarks, copyrights, patent rights, and other intellectual property or other rights in the information, material, as well as any design of the Services, this website or application. Unless otherwise agreed in these Terms or other agreements, the User ​​must not copy, decompile, reverse engineer, decode, distribute or decrypt any material of the Service, or any content available on this website or application.',
              'ผู้ให้บริการเป็นเจ้าของหรือมีซึ่งสิทธิในเนื้อหาและเครื่องหมายการค้า รวมทั้งลิขสิทธิ์ สิทธิบัตร และทรัพย์สินทางปัญญาในข้อมูลที่แสดง รูปภาพ และ รูปแบบการแสดงผล ตามที่ปรากฏในบริการ เว็บไซต์หรือแอปพลิเคชันทั้งหมด ห้ามมิให้ผู้ใดทำการคัดลอก ทำซ้ำ มีสำเนา สำรองไว้ ทำเลียนแบบ ทำเหมือน ดัดแปลง ทำเพิ่ม เพื่อนำไปเผยแพร่ด้วยวัตถุประสงค์อื่นใด โดยปราศจากความยินยอมเป็นหนังสือจากผู้ให้บริการ ทั้งนี้เว้นแต่จะได้มีการระบุกำหนดไว้ในข้อตกลง เงื่อนไขการใช้บริการ และนโยบายความเป็นส่วนตัว'
            )}
          </p>{' '}
        </li>{' '}
        <li>
          <span className={classes.strongStyle}>
            {trans('Disclaimer', 'ความรับผิด')}
          </span>
          <p>
            {trans(
              'The User acknowledges and agrees that:',
              'ผู้ใช้บริการทราบและตกลงตามข้อความดังนี้'
            )}
          </p>{' '}
          <LegalStyleDiv>
            <LegalOrderingDiv>10.1</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `The Service Provider shall not be liable for any damages incurred from the act or omission by the User, improper packaging, or the delivery of the parcel that does not comply with the requirements of the Courier. If the Service Provider is required to compensate the User for any damages, the liability will be limited to the actual value of loss or damage of the shipment, which not exceed 3,000 baht or other amounts as the Service Provider deems appropriate. The Service Provider shall not be liable to any person for indirect loss, punitive damages, loss of profits, damages from data loss or unavailability of the Services.`,
                  `ผู้ให้บริการไม่รับผิดชอบต่อความเสียหายใด ๆ ก็ตามที่เกิดจากความบกพร่องของผู้ใช้บริการหรือเกิดจากการบรรจุหรือห่อหุ้มสิ่งของไม่แข็งแรงหรือการขนส่งพัสดุที่ไม่เป็นไปตามข้อกำหนดของขนส่ง หากผู้ให้บริการจำเป็นต้องชดใช้ค่าเสียหาย ผู้ให้บริการจะรับผิดต่อค่าเสียหายที่แท้จริงที่เกิดขึ้นโดยตรงไม่เกิน 3,000 บาทต่อพัสดุและตามเงื่อนไขของแต่ละขนส่งสำหรับบริการขนส่งด่วนทางอากาศเท่านั้น หรือตามที่ผู้ให้บริการเห็นสมควรเท่านั้น โดยผู้ให้บริการจะไม่รับผิดต่อความเสียหายโดยทางอ้อม ค่าเสียหายเชิงลงโทษ การสูญเสียผลกำไร ความเสียหายที่เป็นผลจากการสูญเสียข้อมูลที่เป็นผลจากการใช้งาน และ/หรือการไม่สามารถใช้บริการต่อบุคคลใด ๆ`
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>10.2</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `If the User causes any damage to the Service Provider, whether intentionally or attempted to act, whether directly or indirectly, the Service Provider shall be entitled to claim for damages or file a lawsuit against the law.`,
                  `หากผู้ใช้บริการก่อให้เกิดความเสียหายใด ๆ ไม่ว่าจงใจกระทำการหรือพยายามกระทำการและไม่ว่าจะโดยตรงหรือโดยอ้อมอันจะทำให้ผู้ให้บริการได้รับความเสียหาย เสียชื่อเสียง หรือสิ่งใด ผู้ให้บริการมีสิทธิเรียกร้องค่าเสียหาย หรือฟ้องร้องดำเนินคดีตามกฎหมายได้`
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>10.3</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `The Service Provider and the User shall not be liable for their inability to perform their duties under these Terms. If the inability to perform such duties is caused by Force Majeure. `,
                  `ผู้ให้บริการและผู้ใช้บริการจะไม่ต้องรับผิดในการไม่สามารถปฏิบัติหน้าที่ของตนภายใต้เงื่อนไขการใช้บริการนี้ ถ้าการไม่สามารถปฏิบัติหน้าที่ดังกล่าวเกิดจากเหตุสุดวิสัย หรือเหตุใดที่อยู่นอกเหนือการควบคุมของผู้ให้บริการ`
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>10.4</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `The User will not claim any damages from the Service Provider in the event that the damage is caused by (a) information inputted or transmission by the User is incorrect; (b) failure of software, hardware, Internet, or electronic communication; (c) the User not comply with these Terms; (d) any event beyond the control of the Service Provider; (e) delivered items classified as fragile (such as glass, ceramics, wood, etc.), electrical and magnetic damage, obliteration of electronic materials, defects or any damages due to the nature of the delivered items (even if the Service Provider is notified of such incidents); and (f) any acts or omissions of the User or any other person that not employed or contracted with the Service Provider such as shippers, consignees, third parties, tax authorities, and other governmental authorities.`,
                  `ผู้ใช้บริการจะไม่เรียกร้องค่าเสียหายใด ๆ จากผู้ให้บริการในกรณีที่ความเสียหายเกิดจาก (ก) การป้อนข้อมูลหรือส่งข้อมูลของผู้ใช้บริการไม่ถูกต้อง (ข) ซอฟต์แวร์ ฮาร์ดแวร์ อินเทอร์เน็ต หรือการสื่อสารทางอิเล็กทรอนิกส์ล้มเหลว (ค) การที่ผู้ใช้บริการไม่ปฏิบัติตามข้อกำหนดนี้  (ง) เหตุการณ์อื่นใดที่นอกเหนือความควบคุมของผู้ให้บริการ (จ) สินค้าที่จัดอยู่ในประเภทเสี่ยงแตกหักได้ง่าย เช่น แก้ว เซรามิก ไม้ และอื่นๆ รวมถึง ความเสียหายทางไฟฟ้าและแม่เหล็ก หรือการลบเลือนที่เกิดขึ้นกับภาพอิเล็กทรอนิกส์และภาพถ่าย ข้อมูล ข้อมูลบันทึกอัดเก็บ หรือความบกพร่องหรือความเสียหายลักษณะอื่นใดที่เกี่ยวข้องตามธรรมชาติของสิ่งของที่จัดส่งถึงแม้ว่าจะมีการแจ้งให้ผู้ให้บริการรับทราบถึงเหตุการณ์ดังกล่าวก็ตาม และ (ฉ) การกระทำหรือการละเว้นการกระทำของผู้ใช้บริการเองหรือบุคคลอื่นใดที่ไม่ได้รับการว่าจ้างหรือทำสัญญากับผู้ให้บริการ เช่น ผู้จัดส่ง ผู้รับ บุคคลที่สาม หน่วยงานภาษีอากรและหน่วยงานรัฐอื่น ๆ`
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>10.5</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `he Service Provider will not be liable for any penalties imposed or loss or damage incurred due to the User’s documents or goods being impounded by customs or other official authorities, and the User hereby indemnifies the Service Provider against such penalty or loss it may incur.`,
                  `ผู้ให้บริการจะไม่รับผิดชอบต่อบทลงโทษใด ๆ ที่กำหนดหรือสูญเสียหรือความเสียหายที่เกิดขึ้นเนื่องจากเอกสารหรือสินค้าหรือพัสดุของผู้ใช้บริการที่ถูกยึดโดยศุลกากรหรือหน่วยงานราชการอื่น ๆ และผู้ใช้บริการชดใช้ค่าเสียหายหรือการสูญเสียที่อาจเกิดขึ้นกับผู้ให้บริการ`
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>10.6</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `In the event that the Service Provider already compensates the User under these Terms, the Service Provider sshall be released from all liability for any loss and damage expressed herein. The User further agrees to waive any and all rights to claim against the Service Provider in all respect of such liability.`,
                  `ในกรณีที่ผู้ให้บริการรับผิดตามเงื่อนไขการใช้บริการนี้แล้ว ผู้ใช้บริการตกลงให้ผู้ให้บริการหลุดพ้นจากความรับผิดชอบทั้งหมดอย่างชัดเจนสำหรับการสูญเสียความเสียหายหรือการจัดการอื่น ๆ ของความรับผิดดังกล่าว และผู้ใช้บริการตกลงสละสิทธิเรียกร้องทั้งหมดที่มีต่อผู้ให้บริการในส่วนที่มีความเกี่ยวข้องกับความรับผิดดังกล่าว`
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>10.7</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `The Service Provider shall be only responsible for the shipment or the Services specified in the registration or the system.`,
                  `ผู้ให้บริการรับผิดชอบเฉพาะการจัดส่งหรือบริการซึ่งปรากฏชื่อผู้ใช้บริการเดียวกับผู้ใช้บริการตามที่ระบุไว้ในการลงทะเบียนหรือในระบบ `
                )}
              </span>
            </div>
          </LegalStyleDiv>
        </li>{' '}
        <li>
          <p>
            <span className={classes.strongStyle}>
              {trans(
                'Amendment, Suspension, Refusal, or Cancellation of the Services',
                'การเปลี่ยนแปลง ระงับ ปฏิเสธหรือยกเลิกการบริการ'
              )}
            </span>
          </p>
          <LegalStyleDiv>
            <LegalOrderingDiv>11.1</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `These Services are provided ‘AS IS’ and ‘AS AVAILABLE’. The Service Provider reserves the right to temporarily suspend or cancel these Services, even if the User does not breach these Terms or the Privacy Policy and the Service Provider will only refund the remaining amount of the actual Service Fee to the User.  The refund is subject to the terms of the service fee specified by the Service Provider. The User cannot claim any compensation other than the paid Service Fee.`,
                  `บริการนี้เป็นการให้บริการตามสภาพที่เป็นอยู่ (AS IS) และมีอยู่ (AS AVAILABLE) ผู้ให้บริการสามารถระงับหรือยกเลิกการใช้บริการแก่ผู้ใช้บริการใดๆ ตามเห็นสมควรได้ ถึงแม้ว่าผู้ใช้บริการจะไม่ได้ละเมิดข้อตกลง เงื่อนไขการใช้การบริการ และนโยบายความเป็นส่วนตัวใด ๆ ก็ตาม โดยผู้ให้บริการจะคืนค่าบริการตามจริงเฉพาะที่ยังไม่ได้ใช้งานเท่านั้น ทั้งนี้ ให้เป็นไปตามเงื่อนไขของค่าบริการที่ผู้ให้บริการกำหนดไว้ และผู้ใช้บริการไม่สามารถเรียกร้องค่าเสียหายอื่น ๆ นอกเหนือจากค่าบริการที่ผู้ใช้บริการได้ชำระกับผู้ให้บริการแล้วเท่านั้น`
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>11.2</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `If the User does not log in to his/her account for a long time, the Service Provider may suspend the Services for the User without prior notice.`,
                  `ผู้ให้บริการสามารถระงับการให้บริการแก่ผู้ใช้บริการในกรณีที่ผู้ใช้บริการไม่เข้าสู่ระบบเป็นเวลานานโดยมิต้องแจ้งให้ทราบล่วงหน้า`
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>11.3</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `The Service Provider may temporarily suspend the Services due to some necessity, including Force majeure or any other event beyond the control of the Service Provider, the malfunction in equipment or software, communications failure or delay in operation, unavailability of the Services for system maintenance or improvement or other interferences that may affect the Services. The Service Provider reserves the right not to refund the Service fee for the period of the suspension of such service and the Service Provider shall have no liability due to such suspension in all respects.`,
                  `ผู้ให้บริการอาจระงับการให้บริการเป็นการชั่วคราวด้วยเหตุจำเป็นบางประการ ซึ่งรวมถึงเหตุสุดวิสัยหรือข้อบกพร่องที่ไม่สามารถคาดการณ์ได้ล่วงหน้า อันอาจจะเกิดจุดบกพร่องของอุปกรณ์ ซอฟต์แวร์ การปรับปรุงระบบหรือสิ่งอื่นใดที่มีผลกระทบต่อการใช้บริการและให้บริการ และในกรณีที่มีการระงับบริการประเภทที่มีค่าบริการ ขอสงวนสิทธิ์ในการไม่คืนค่าบริการสำหรับระยะเวลาที่ระงับบริการดังกล่าว และถือว่าผู้ให้บริการไม่มีความรับผิดในการระงับบริการดังกล่าวไม่ว่าประการใด`
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>11.4</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `The Service Provider may cease the Service provided to the User for the following reasons: (a) the User uses the Service for any illegal actions, obscene or fraudulent purpose, or for any prohibited purpose which is against the law or regulation of the origins and destination countries; (b) the User's failure to pay any outstanding payments to the Service Provider on the due date; and (c) the User breach these Terms and other conditions of use.`,
                  `ผู้ให้บริการอาจยุติการให้บริการแก่ผู้ใช้บริการด้วยสาเหตุดังต่อไปนี้ (ก) การใช้บริการของเพื่อวัตถุประสงค์ที่ผิดกฎหมาย การลามกอนาจารหรือฉ้อโกงหรือเพื่อวัตถุประสงค์ที่ห้ามซึ่งผิดกฎหมายหรือข้อบังคับของประเทศต้นทาง ประเทศปลายทางหรือกฎระเบียบหรือกฎหมายอื่น ๆ (ข) ความล้มเหลวของผู้ใช้บริการในการชำระเงินที่ค้างชำระกับผู้ให้บริการเมื่อถึงกำหนด และ (ค) การละเมิดข้อกำหนดและเงื่อนไขการใช้บริการใด ๆ เหล่านี้`
                )}
              </span>
            </div>
          </LegalStyleDiv>
        </li>{' '}
        <li>
          <p>
            <span className={classes.strongStyle}>
              {trans('Modification', 'การแก้ไขเปลี่ยนแปลง')}
            </span>
          </p>
          <p>
            {trans(
              'The Service Provider may, without prior notice, change these Terms or the Privacy Policy from time to time to reflect the Services and to comply with the laws. However, the User can check the updated Terms or Privacy through this websites or applications before using the Services. If the User disagrees with these Terms, please do not continue to use the Service. The continued use of the Services after changes become effective will mean that the User accepts those changes. ',
              'ผู้ให้บริการสามารถเปลี่ยนแปลง ข้อตกลง เงื่อนไขการใช้บริการ นโยบายความเป็นส่วนตัว ข้อกำหนด สัญญา และหรือชื่ออื่นใดอันมีความหมายเช่นเดียวกันในการให้บริการได้โดยไม่จำเป็นต้องแจ้งให้ทราบล่วงหน้าเพื่อให้สอดคล้องกับการให้บริการในปัจจุบันและกฎหมาย โดยผู้ใช้บริการสามารถตรวจสอบการเปลี่ยนแปลงเงื่อนไขการใช้บริการได้ผ่านทางเว็บไซต์หรือแอปพลิเคชันนี้'
            )}
            {trans(
              '',
              'ทั้งนี้ โปรดยุติการใช้บริการของเราหากผู้ใช้บริการไม่ตกลงตามเงื่อนไขการใช้บริการที่เปลี่ยนแปลงการที่ผู้ใช้บริการเข้าใช้งานภายหลังการเปลี่ยนแปลงเงื่อนไขการใช้บริการจะถือว่าผู้ใช้บริการตกลงที่จะปฏิบัติตามเงื่อนไขการใช้บริการที่เปลี่ยนแปลงดังกล่าว '
            )}
          </p>{' '}
        </li>{' '}
        <li>
          <span className={classes.strongStyle}>
            {trans(
              'Communication and Complaint Channels',
              'การติดต่อและการร้องเรียน'
            )}
          </span>
          <p>
            {trans(
              'If the User has any questions or wishes to contact us, the User can contact us through cs@shippop.com, from Monday to Sunday, from 9.00 a.m. - 6.00 p.m. (except public holidays).',
              'กรณีผู้ใช้บริการเกิดปัญหาในการใช้บริการหรือต้องการติดต่อผู้ให้บริการ ผู้ใช้บริการสามารถติดต่อผู้ให้บริการผ่านทาง email : cs@shippop.com'
            )}
          </p>{' '}
        </li>{' '}
        <li>
          <span className={classes.strongStyle}>
            {trans('Liability', 'การคุ้มครองพัสดุ')}
          </span>
          <p>
            {trans(
              'The Montreal Convention or the Warsaw Convention for international shipping, road freight agreements (CMRs) may be applied and limited liability for any loss or damage of shipment, if the delivery is air freight that sends to or stops in countries other than the country where the delivered packages are exported.',
              'ถ้าการจัดส่งนั้นเป็นการขนส่งทางอากาศ และไปยังที่หมายสุดท้ายหรือหยุดในประเทศอื่น ๆ นอกจากประเทศที่พัสดุถูกส่งออกให้มีการจัดการและบังคับใช้ตามหลักอนุสัญญามอนทรีออล หรืออนุสัญญาวอร์ซอว์ สำหรับการขนส่งระหว่างชาติอาจมีการใช้ข้อตกลงการขนส่งสินค้าทางถนน (ซีเอ็มอาร์) ทั้งนี้ ข้อตกลงและอนุสัญญาเหล่านี้จะจำกัดความรับผิดชอบในความสูญหายหรือความเสียหายที่เกิดขึ้น'
            )}
          </p>{' '}
          <p>
            {trans(
              'Our liability of any shipment that not covered by insurance is limited to direct loss and damagewith a maximum of 3,000 baht per parcel which in accordance with the conditions of each shipment for air express services (for the international shipment), or any other amount prescribed under the terms and conditions of each Courier. The liability under this provision will not cover any delivery fee. In the event that additional insurance is purchased, the parcel will be covered under that insurance policy.',
              'สำหรับพัสดุที่ไม่ได้ซื้อความคุ้มครองไว้ ความรับผิดชอบของเราในการจัดส่งพัสดุนั้นจะจำกัดเพียงกรณีเกิดความเสียหายและสูญหายโดยตรงซึ่งมีมูลค่าชดเชยสูงสุดไม่เกิน 3,000 บาท ต่อพัสดุ 1 ชิ้น และตามเงื่อนไขของแต่ละขนส่งสำหรับบริการขนส่งด่วนทางอากาศ หรือตามจำนวนเงินอื่นใดที่ผู้ให้บริการขนส่งกำหนดภายใต้เงื่อนไขของผู้ให้บริการขนส่งแต่ละราย โดยการคุ้มครองข้างต้นจะไม่ครอบคลุมในส่วนของค่าบริการจัดส่ง ในกรณีที่มีการซื้อประกันเพิ่มเติมให้การคุ้มครองพัสดุอยู่ภายใต้เงื่อนไขการประกันนั้น ๆ'
            )}
          </p>{' '}
        </li>{' '}
        <li>
          <span className={classes.strongStyle}>
            {trans('Filing a Claim', 'การเคลมพัสดุ')}
          </span>
          <p>
            {trans(
              'If the User wishes to make a claim after the delivered parcel has been received, the User shall submit all required documents and related evidence in writing  through cs@shippop.com or Line: @SHIPPOP within 15 days after the Service Provider responds to the delivery. The appropriation of the claim request and damage insurance will be considered by the Service Provider only. In the event that the claim is submitted after the aforementioned period, the Service Provider reserves the right not to be responsible for any damage caused to the delivered parcel.',
              'หากผู้ใช้บริการต้องการเคลมพัสดุหลังจากที่มีการรับพัสดุแล้ว ผู้ใช้บริการจะต้องยื่นเอกสารเคลมและหลักฐานที่เกี่ยวข้องผ่านอีเมล cs@shippop.com หรือ Line : @SHIPPOP การเรียกร้องความเสียหายทุกชนิดจะต้องเป็นลายลักษณ์อักษรและส่งถึงผู้ให้บริการภายใน 15 วัน หลังจากวันที่ผู้ให้บริการตอบรับสินค้าเพื่อการจัดส่ง โดยผู้ให้บริการจะพิจารณาถึงความเหมาะสมในการขอเคลมสินค้าและประกันความเสียหาย ในกรณีที่มีการยื่นเคลมเกินระยะเวลาดังกล่าว ผู้ให้บริการขอสงวนสิทธิ์ไม่รับผิดชอบต่อความเสียหายใด ๆ ที่เกิดกับพัสดุ'
            )}
          </p>{' '}
        </li>{' '}
        <li>
          <p>
            <span className={classes.strongStyle}>
              {trans('Miscellaneous', 'ข้อกำหนดอื่น ๆ ')}
            </span>
          </p>{' '}
          <LegalStyleDiv>
            <LegalOrderingDiv>16.1</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `If any provision of these Terms becomes or is found to be invalid, illegal, or unenforceable in any respect, the validity, legality, and enforceability of the remaining provisions shall in no way be affected or impaired thereby.`,
                  `หากข้อกำหนด ข้อตกลง สัญญา หรือข้อความใดในเงื่อนไขการใช้บริการนี้เป็นโมฆะหรือโมฆียะให้เป็นไปตามกฎหมายของไทยเท่านั้น ทั้งนี้ให้ยกเว้นส่วนที่ไม่ได้เป็นโมฆะหรือโมฆียะให้ใช้บังคับต่อไป`
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>16.2</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `These Terms are written in English and Thai language. In the event of conflict or discrepancy between English and Thai language, the Thai language shall prevail over.`,
                  `กรณีที่ข้อความใด ๆ มีความขัดหรือแย้งกัน ในฉบับภาษาไทยและฉบับแปลภาษาอื่น ๆ ให้ถือตามฉบับภาษาไทยมีผลเหนือฉบับแปลภาษาอื่น ๆ`
                )}
              </span>
            </div>
          </LegalStyleDiv>
          <LegalStyleDiv>
            <LegalOrderingDiv>16.3</LegalOrderingDiv>
            <div>
              <span>
                {trans(
                  `These Terms and all matters relating to the use of the Services are governed by and construed in accordance with the laws of Thailand. The courts of Thailand will have an exclusive jurisdiction to adjudicate any dispute arising under or in connection with these Terms.`,
                  `การกระทำใด ๆ ก็ตามที่มีผลต่อการใช้บริการของผู้ให้บริการและผู้ใช้บริการให้อยู่ภายใต้การบังคับของกฎหมายไทยเท่านั้น โดยไม่คำนึงสถานที่ตั้งของระบบ ข้อมูล และการใช้งาน รวมถึงกฎหรือบทบัญญัติว่าด้วยการเลือกกฎหมายหรือการขัดกันของกฎหมาย และให้ศาลในราชอาณาจักรไทยเป็นศาลที่มีเขตอำนาจในการพิจารณาชี้ขาดตัดสินข้อพิพาทที่เกิดขึ้นภายใต้ ข้อตกลง เงื่อนไขการใช้บริการ และนโยบายความเป็นส่วนตัว`
                )}
              </span>
            </div>
          </LegalStyleDiv>
        </li>
      </ol>
    </>
  )

  const META = {
    title: 'เงื่อนไขการใช้บริการ เงื่อนไขขนส่ง - SHIPPOP',
    keywords: 'เงื่อนไข, เงื่อนไขขนส่ง, เงื่อนไขการใช้งาน, ส่งของ, เช็คค่าส่ง',
    description:
      'เงื่อนไขการใช้งานขนส่ง เงื่อนไขการรับประกัน เงื่อนไขการเคลม ไปรษณีย์ เคอรี่ แฟลช นินจา เบส ซีเจ scg และทุกขนส่ง',
  }

  // CONTENT identical for both variants; only the chrome differs.
  const content = (
        <div className={classes.page}>
          <Container>
            <Paper elevation={3} className={classes.paper}>
              <Tabs
                value={activeTab}
                onChange={(e, newValue) => setActiveTab(newValue)}
                indicatorColor="primary"
                textColor="primary"
                centered
              >
                <Tab
                  label={trans('Domestic', 'ภายในประเทศ')}
                  icon={
                    <img src="/static/img/home/checkprice-icon-truck.svg" />
                  }
                />
                <Tab
                  label={trans('International', 'ระหว่างประเทศ')}
                  icon={
                    <img src="/static/img/home/checkprice-icon-plane.svg" />
                  }
                />
              </Tabs>
              <Divider />
              {activeTab === 0 ? <DomesticContent /> : <InterContent />}

              <ConsentUpdateDetail isEnglish={isEnglish} />
            </Paper>
          </Container>
        </div>
  )

  // ?new: new-design chrome (NewShell provides Layout + HeaderNew + FooterNew).
  if (isNew) {
    return <NewShell {...META}>{content}</NewShell>
  }

  // Default (no ?new): original chrome, unchanged.
  return (
    <div className={classes.root}>
      <Layout {...META}>{content}</Layout>
    </div>
  )
}

export default Terms
